// import { useEffect, useMemo, useState } from "react";
// import { Eye, EyeOff, Loader2, Mail, Maximize, X, Link as LinkIcon, Save, Send } from "lucide-react";
// import { letterSchema, extractErrors } from "./services/letterValidationSchema.ts";
// import QrVerificationCard from "./components/letter/QrVerificationCard";
// import { ESignModal, LetterContentCard, LetterPreview, RecipientCard, SignatureModal, SignatureSettingsCard } from "./components/index.js";
// import { useLetterhead } from "./hooks/useLetterhead.ts";
// import { useLocation, useNavigate } from "react-router-dom";
// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';
// import { useDispatch, useSelector } from "react-redux";
// import { getTemplates } from "../../../Redux/Reducers/letterHeadReducer.ts";
// import { toast } from "react-toastify";

// // export default function ComposeLetterPage() {
// //   const location = useLocation();

// //   const applicant = location.state?.applicant;
// //   const applicationId = location.state?.applicationId;

// //   console.log("applicantkjsnfcskjnf", applicant);
// //   console.log("applicationId-mmm", applicationId);


// //   const {
// //     templates,
// //     isLoading,
// //     isEditMode,
// //     companyProfile,
// //     letterState: state,
// //     updateLetterState: updateState,
// //     processedTemplate,
// //     isSignatureModalOpen,
// //     setIsSignatureModalOpen,
// //     isESignModalOpen,
// //     setIsESignModalOpen,
// //     handleSaveLetter: handleSave,
// //     handleESignSuccess,
// //     setLetterState,
// //     iquiqueCode,
// //     isSendingEmail
// //   } = useLetterhead();

// //   const [errors, setErrors] = useState({});
// //   const [showPreview, setShowPreview] = useState(true);
// //   const [isFullscreenPreview, setIsFullscreenPreview] = useState(false);

// //   const qrCardState = {
// //     ...state,
// //     subject: state.subjectQr
// //   };

// //   const handleQrCardUpdate = (updater) => {
// //     setLetterState(prev => {
// //       const newState = typeof updater === 'function' ? updater(prev) : updater;
// //       if (newState.subject !== undefined && newState.subject !== prev.subject) {
// //         return { ...newState, subjectQr: newState.subject, subject: prev.subject };
// //       }
// //       return newState;
// //     });
// //   };

// //   const validateAndSubmit = async (actionType) => {
// //     if (actionType === 'SEND_FINAL' && !state.recipientEmail) {
// //       alert("Please provide a recipient email address before sending the final document.");
// //       return;
// //     }

// //     try {
// //       setErrors({});
// //       await letterSchema.validate(state, { abortEarly: false });
// //       handleSave(actionType);
// //     } catch (err) {
// //       const validationErrors = extractErrors(err);
// //       setErrors(validationErrors);
// //     }
// //   };

// //   // New function for "Send to Applicant" action
// //   const handleSendToApplicant = async () => {
// //     if (!applicant?.email) {
// //       alert("Applicant email not found. Please add applicant information.");
// //       return;
// //     }

// //     try {
// //       setErrors({});
// //       await letterSchema.validate(state, { abortEarly: false });
// //       // You can call a different action type or modify handleSave to handle this
// //       // handleSave('SEND_TO_APPLICANT');
// //     } catch (err) {
// //       const validationErrors = extractErrors(err);
// //       setErrors(validationErrors);
// //     }
// //   };

// //   // const rightButtons = (
// //   //   <div className="d-flex align-items-center gap-3">
// //   //     {/* <select
// //   //       value={state.templateId ? String(state.templateId) : ""}
// //   //       onChange={(e) => updateState("templateId", e.target.value)}
// //   //       className="form-select form-select-sm w-auto"
// //   //       style={{ fontSize: "0.875rem", cursor: "pointer" }}
// //   //     >
// //   //       <option value="">Select Template</option>
// //   //       {templates?.map(t => (
// //   //         <option key={t.template_id} value={String(t.template_id)}>
// //   //           {t.template_name}
// //   //         </option>
// //   //       ))}
// //   //     </select>

// //   //     <button
// //   //       onClick={() => setShowPreview(!showPreview)}
// //   //       className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
// //   //       style={{ fontWeight: 500 }}
// //   //     >
// //   //       {showPreview ? <><EyeOff size={18} /> Hide</> : <><Eye size={18} /> Show</>}
// //   //     </button> */}

// //   //     {state.signatureType === 'send_link' ? (
// //   //       state.signatories?.some(sig => sig.status === 'PENDING' || !sig.status) ? (
// //   //         <button
// //   //           onClick={() => validateAndSubmit('SEND_LINK')}
// //   //           disabled={isLoading || isSendingEmail}
// //   //           className="btn btn-primary btn-sm d-flex align-items-center gap-2"
// //   //           style={{ backgroundColor: "#4f46e5", borderColor: "#4f46e5" }}
// //   //         >
// //   //           {isSendingEmail ? <Loader2 className="spinner-border spinner-border-sm" size={16} /> : <LinkIcon size={16} />}
// //   //           {isSendingEmail ? "Sending..." : (state.status === 'PENDING_SIGNATURE' || state.status === 'SIGNED' ? "Resend / Signing Link" : "Send Signing Link")}
// //   //         </button>
// //   //       ) : (
// //   //         <button
// //   //           onClick={() => validateAndSubmit('SEND_FINAL')}
// //   //           disabled={isLoading || isSendingEmail}
// //   //           className="btn btn-success btn-sm d-flex align-items-center gap-2"
// //   //         >
// //   //           {isSendingEmail ? <Loader2 className="spinner-border spinner-border-sm" size={16} /> : <Mail size={16} />}
// //   //           {isSendingEmail ? "Sending..." : "Send Final Email"}
// //   //         </button>
// //   //       )
// //   //     ) : (
// //   //       <button
// //   //         onClick={() => validateAndSubmit('SEND_FINAL')}
// //   //         disabled={isLoading || isSendingEmail}
// //   //         className="btn btn-success btn-sm d-flex align-items-center gap-2"
// //   //       >
// //   //         {isSendingEmail ? <Loader2 className="spinner-border spinner-border-sm" size={16} /> : <Mail size={16} />}
// //   //         {isSendingEmail ? "Sending..." : (state.status === 'SENT' ? "Resend Email" : "Send Email")}
// //   //       </button>
// //   //     )}

// //   //     <button
// //   //       onClick={() => validateAndSubmit('SAVE')}
// //   //       disabled={isLoading || isSendingEmail}
// //   //       className="btn btn-primary btn-sm d-flex align-items-center gap-2"
// //   //     >
// //   //       {isLoading && !isSendingEmail && <Loader2 className="spinner-border spinner-border-sm" size={16} />}
// //   //       {isLoading && !isSendingEmail ? "Saving..." : (isEditMode ? "Update Letter" : "Save Letter")}
// //   //     </button>
// //   //   </div>
// //   // );


// //   const rightButtons = (
// //     <div className="d-flex align-items-center gap-3">
// //       {/* Center Button - Send Email */}
// //       <button
// //         onClick={() => validateAndSubmit('SEND_FINAL')}
// //         disabled={isLoading || isSendingEmail}
// //         className="btn btn-primary btn-sm d-flex align-items-center gap-2"
// //         style={{ backgroundColor: "#4f46e5", borderColor: "#4f46e5" }}
// //       >
// //         {isSendingEmail ? <Loader2 className="spinner-border spinner-border-sm" size={16} /> : <Mail size={16} />}
// //         {isSendingEmail ? "Sending..." : "Send Email"}
// //       </button>

// //       {/* Save Letter Button */}
// //       <button
// //         onClick={() => validateAndSubmit('SAVE')}
// //         disabled={isLoading || isSendingEmail}
// //         className="btn btn-outline-primary btn-sm d-flex align-items-center gap-2"
// //         style={{ borderColor: "#4f46e5", color: "#4f46e5" }}
// //       >
// //         {isLoading && !isSendingEmail ? <Loader2 className="spinner-border spinner-border-sm" size={16} /> : <Save size={16} />}
// //         {isLoading && !isSendingEmail ? "Saving..." : (isEditMode ? "Update Letter" : "Save Letter")}
// //       </button>

// //       {/* Send to Applicant Button */}
// //       <button
// //         onClick={handleSendToApplicant}
// //         disabled={isLoading || isSendingEmail || !applicant?.email}
// //         className="btn btn-success btn-sm d-flex align-items-center gap-2"
// //         style={{ backgroundColor: "#10b981", borderColor: "#10b981" }}
// //       >
// //         {isSendingEmail ? <Loader2 className="spinner-border spinner-border-sm" size={16} /> : <Send size={16} />}
// //         {isSendingEmail ? "Sending..." : "Send to Applicant"}
// //       </button>
// //     </div>
// //   );



// //   return (
// //     <div className="vh-100 d-flex flex-column bg-light" style={{ backgroundColor: "#f8fafc" }}>
// //       {/* Main Content Grid */}
// //       <div className="flex-grow-1 w-100 p-4 overflow-hidden">
// //         <div className={`row g-4 h-100 ${!showPreview ? "justify-content-center" : ""}`}>

// //           {/* Left Form Column */}
// //           <div className={`${showPreview ? "col-lg-6 col-xl-7" : "col-lg-8 col-xl-6"} h-100 overflow-auto pe-2`} style={{ scrollbarWidth: "thin" }}>
// //             <div className="d-flex flex-column gap-4 pb-5">
// //               <RecipientCard
// //                 state={state}
// //                 updateState={updateState}
// //                 applicant={applicant}
// //                 errors={errors}
// //               />
// //               <LetterContentCard
// //                 state={state}
// //                 updateState={updateState}
// //                 applicant={applicant}
// //                 errors={errors}
// //               />
// //               <SignatureSettingsCard
// //                 state={state}
// //                 updateState={updateState}
// //                 openModal={() => setIsSignatureModalOpen(true)}
// //                 openESignModal={() => setIsESignModalOpen(true)}
// //               />
// //               <QrVerificationCard
// //                 templateState={qrCardState}
// //                 setTemplateState={handleQrCardUpdate}
// //                 errors={errors}
// //                 companyName={companyProfile?.name}
// //                 iquiqueCode={iquiqueCode}
// //               />
// //             </div>
// //             <div style={{ width: "100%", display: "flex", justifyContent: "space-evenly" }}>
// //               {rightButtons}


// //             </div>
// //           </div>

// //           {/* Right Preview Column */}
// //           {showPreview && (
// //             <div className="col-lg-6 col-xl-5 h-100 position-relative">
// //               <div className="bg-white rounded-3 border shadow-sm h-100 position-relative overflow-hidden">
// //                 {/* Fullscreen Button */}
// //                 <button
// //                   onClick={() => setIsFullscreenPreview(true)}
// //                   className="btn btn-light position-absolute top-0 end-0 m-3 rounded-circle shadow-sm d-flex align-items-center justify-content-center"
// //                   style={{ width: "38px", height: "38px", zIndex: 10 }}
// //                   title="Full Screen Preview"
// //                 >
// //                   <Maximize size={18} />
// //                 </button>

// //                 <div className="h-100 overflow-auto">
// //                   <LetterPreview
// //                     state={state}
// //                     selectedTemplate={processedTemplate}
// //                     companyProfile={companyProfile}
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           )}
// //         </div>
// //       </div>

// //       {/* Signature Modal */}
// //       {isSignatureModalOpen && (
// //         <SignatureModal
// //           initialSignature={state.drawnSignature}
// //           onClose={() => setIsSignatureModalOpen(false)}
// //           onSave={(signatureData) => {
// //             updateState("drawnSignature", signatureData);
// //             setIsSignatureModalOpen(false);
// //           }}
// //         />
// //       )}

// //       {/* Aadhaar eSign Modal */}
// //       {isESignModalOpen && (
// //         <ESignModal
// //           onClose={() => setIsESignModalOpen(false)}
// //           onVerified={handleESignSuccess}
// //         />
// //       )}

// //       {/* Full Screen Preview Modal */}
// //       {isFullscreenPreview && (
// //         <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: "rgba(15, 23, 42, 0.6)", backdropFilter: "blur(4px)", zIndex: 1050 }}>
// //           <div className="bg-white rounded-4 shadow-lg d-flex flex-column" style={{ width: "90%", height: "90%", maxWidth: "1200px" }}>
// //             {/* Modal Header */}
// //             <div className="d-flex justify-content-between align-items-center p-4 border-bottom">
// //               <h5 className="fw-bold mb-0">Full Screen Preview</h5>
// //               <button
// //                 onClick={() => setIsFullscreenPreview(false)}
// //                 className="btn btn-link text-dark p-0"
// //                 style={{ fontSize: "1.5rem" }}
// //               >
// //                 <X size={24} />
// //               </button>
// //             </div>
// //             {/* Modal Body */}
// //             <div className="flex-grow-1 overflow-auto bg-light p-4">
// //               <LetterPreview
// //                 state={state}
// //                 selectedTemplate={processedTemplate}
// //                 companyProfile={companyProfile}
// //               />
// //             </div>
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // }

// // export default function ComposeLetterPage() {
// //   const location = useLocation();
// //   const navigate = useNavigate();
// //   const dispatch = useDispatch()
// //   const applicant = location.state?.applicant;
// //   const applicationId = location.state?.applicationId;

// //   const {
// //     templates,
// //     isLoading,
// //     isEditMode,
// //     companyProfile,
// //     letterState: state,
// //     updateLetterState: updateState,
// //     processedTemplate,
// //     isSignatureModalOpen,
// //     setIsSignatureModalOpen,
// //     isESignModalOpen,
// //     setIsESignModalOpen,
// //     handleSaveLetter: handleSave,
// //     handleESignSuccess,
// //     setLetterState,
// //     iquiqueCode,
// //     isSendingEmail,
// //   } = useLetterhead();

// //   const [errors, setErrors] = useState({});
// //   const [showPreview, setShowPreview] = useState(true);
// //   const [isFullscreenPreview, setIsFullscreenPreview] = useState(false);
// //   const [isAttaching, setIsAttaching] = useState(false);
// //   // Use the template from Redux or fallback to processedTemplate
// //   const selectedTemplateFromRedux = useSelector((state) => state.letterHead.template);
// //   const ProfessionalExperience =
// //     useSelector((state) => state?.ProfileArray?.experienceData?.data) || [];

// //   const cid = ProfessionalExperience[0]?.companyDetails?.data[0]?.cid || "";

// //   // console.log("JHVHJVVJ", cid)
// //   // Determine which template to use (prefer Redux one if available)
// //   const activeTemplate = selectedTemplateFromRedux || processedTemplate;

// //   const qrCardState = {
// //     ...state,
// //     subject: state.subjectQr
// //   };

// //   useEffect(() => {
// //     if (applicant?.role && !state.subject) {
// //       updateState("subject", `Offer Letter for ${applicant.role} Position`);
// //     }
// //   }, [applicant?.role, state.subject, updateState]);

// //   const handleQrCardUpdate = (updater) => {
// //     setLetterState(prev => {
// //       const newState = typeof updater === 'function' ? updater(prev) : updater;
// //       if (newState.subject !== undefined && newState.subject !== prev.subject) {
// //         return { ...newState, subjectQr: newState.subject, subject: prev.subject };
// //       }
// //       return newState;
// //     });
// //   };

// // Function to generate PDF and save as file
// // const generateAndSavePDF = async () => {
// //   const previewElement = document.querySelector('.letter-preview-content');
// //   if (!previewElement) {
// //     throw new Error('Preview element not found');
// //   }

// //   // Create a clone of the preview element to avoid modifying the original
// //   const element = previewElement.cloneNode(true);
// //   element.style.width = '800px';
// //   element.style.padding = '40px';
// //   element.style.backgroundColor = 'white';
// //   element.style.position = 'absolute';
// //   element.style.top = '-10000px';
// //   document.body.appendChild(element);

// //   try {
// //     const canvas = await html2canvas(element, {
// //       scale: 2,
// //       logging: false,
// //       useCORS: true,
// //       backgroundColor: '#ffffff'
// //     });

// //     const imgData = canvas.toDataURL('image/png');
// //     const pdf = new jsPDF({
// //       unit: 'mm',
// //       format: 'a4',
// //       orientation: 'portrait'
// //     });

// //     const imgWidth = 210; // A4 width in mm
// //     const imgHeight = (canvas.height * imgWidth) / canvas.width;

// //     pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);

// //     // Clean up
// //     document.body.removeChild(element);

// //     return pdf;
// //   } catch (error) {
// //     document.body.removeChild(element);
// //     throw error;
// //   }
// // };

// //   const generateAndSavePDF = async () => {
// //   const previewElement =
// //     document.querySelector('.single-page-wrapper') ||
// //     document.querySelector('.letter-preview-content');

// //   if (!previewElement) {
// //     throw new Error('Preview element not found');
// //   }

// //   const element = previewElement.cloneNode(true);
// //   element.style.width = '794px';
// //   element.style.minHeight = '1122px';
// //   element.style.backgroundColor = '#ffffff';
// //   element.style.position = 'absolute';
// //   element.style.top = '-10000px';
// //   element.style.left = '0';
// //   element.style.boxShadow = 'none';
// //   element.style.padding = '0';
// //   element.style.visibility = 'visible';

// //   document.body.appendChild(element);
// //   await new Promise((resolve) => setTimeout(resolve, 150));

// //   try {
// //     const canvas = await html2canvas(element, {
// //       scale: 2,
// //       logging: false,
// //       useCORS: true,
// //       backgroundColor: '#ffffff',
// //       scrollX: 0,
// //       scrollY: 0,
// //       windowWidth: element.scrollWidth,
// //       windowHeight: element.scrollHeight
// //     });

// //     const imgData = canvas.toDataURL('image/png');
// //     const pdf = new jsPDF({
// //       unit: 'mm',
// //       format: 'a4',
// //       orientation: 'portrait'
// //     });

// //     const imgWidth = 210;
// //     const imgHeight = (canvas.height * imgWidth) / canvas.width;
// //     pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);

// //     document.body.removeChild(element);
// //     return pdf;
// //   } catch (error) {
// //     document.body.removeChild(element);
// //     throw error;
// //   }
// // };

// //   const handleAttachOfferLetter = async () => {
// //     setIsAttaching(true);

// //     try {
// //       setErrors({});

// //       // Generate PDF
// //       const pdf = await generateAndSavePDF();

// //       // Generate filename
// //       const fileName = `offer_letter_${applicationId || Date.now()}_${Date.now()}.pdf`;

// //       // Save PDF as file using blob
// //       const pdfBlob = pdf.output('blob');

// //       // Create a download link and trigger download (optional - to save locally)
// //       const downloadLink = document.createElement('a');
// //       const url = URL.createObjectURL(pdfBlob);
// //       downloadLink.href = url;
// //       downloadLink.download = fileName;
// //       document.body.appendChild(downloadLink);
// //       downloadLink.click();
// //       document.body.removeChild(downloadLink);
// //       URL.revokeObjectURL(url);

// //       // Prepare metadata for localStorage (without the large PDF data)
// //       const letterMetadata = {
// //         letterState: {
// //           recipientEmail: state.recipientEmail,
// //           recipientName: state.recipientName,
// //           subject: `Offer Letter for ${applicant.role} Position` || state.subject,
// //           // subject: `Offer Letter for ${applicant.role} Position` ,
// //           body: state.body,
// //           closingNote: state.closingNote,
// //           senderName: state.senderName,
// //           senderDesignation: state.senderDesignation,
// //           signatureType: state.signatureType,
// //           isSigned: state.isSigned,
// //           drawnSignature: state.drawnSignature ? '[SIGNATURE_PRESENT]' : null
// //         },
// //         applicant: applicant ? {
// //           name: applicant.name,
// //           email: applicant.email,
// //           id: applicant.id
// //         } : null,
// //         applicationId: applicationId,
// //         companyProfile: companyProfile ? {
// //           name: companyProfile.name,
// //           email: companyProfile.email
// //         } : null,
// //         iquiqueCode: iquiqueCode,
// //         timestamp: new Date().toISOString(),
// //         generatedAt: new Date().toLocaleString(),
// //         fileName: fileName,
// //         fileSize: pdfBlob.size,
// //         status: 'attached'
// //       };

// //       // Store metadata in localStorage (this is small enough)
// //       try {
// //         localStorage.setItem('attachedOfferLetter', JSON.stringify(letterMetadata));
// //       } catch (storageError) {
// //         console.warn('Could not store in localStorage, but PDF was downloaded:', storageError);
// //       }

// //       // Optional: Store in sessionStorage as backup (also limited but smaller)
// //       try {
// //         sessionStorage.setItem('lastOfferLetterMetadata', JSON.stringify({
// //           ...letterMetadata,
// //           timestamp: Date.now()
// //         }));
// //       } catch (e) {
// //         console.warn('Session storage also failed:', e);
// //       }

// //       // Create a reference object that can be stored in IndexedDB for larger data
// //       const dbRequest = indexedDB.open('OfferLettersDB', 1);

// //       dbRequest.onupgradeneeded = function (event) {
// //         const db = event.target.result;
// //         if (!db.objectStoreNames.contains('pdfs')) {
// //           db.createObjectStore('pdfs', { keyPath: 'id' });
// //         }
// //       };

// //       dbRequest.onsuccess = function (event) {
// //         const db = event.target.result;
// //         const transaction = db.transaction(['pdfs'], 'readwrite');
// //         const store = transaction.objectStore('pdfs');

// //         // Store the PDF blob in IndexedDB
// //         const pdfData = {
// //           id: fileName,
// //           pdfBlob: pdfBlob,
// //           metadata: letterMetadata,
// //           timestamp: Date.now()
// //         };

// //         store.put(pdfData);

// //         transaction.oncomplete = () => {
// //           console.log('PDF stored in IndexedDB successfully');
// //           // Also store a reference in localStorage
// //           localStorage.setItem('lastOfferLetterId', fileName);
// //         };

// //         transaction.onerror = (error) => {
// //           console.error('IndexedDB storage failed:', error);
// //         };
// //       };

// //       console.log('Offer letter generated and saved successfully');

// //       // Show success message
// //       toast.success('Offer letter has been generated and saved successfully!', {
// //         position: "top-right",
// //         autoClose: 3000,  
// //       })

// //       // alert(`Offer letter has been generated and saved as "${fileName}"`);

// //       // Navigate back to previous page
// //       setTimeout(() => {
// //         navigate(-1);
// //       }, 1500);

// //     } catch (err) {
// //       console.error('Error attaching offer letter:', err);
// //       alert('Failed to generate PDF. Please try again. Error: ' + err.message);
// //     } finally {
// //       setIsAttaching(false);
// //     }
// //   };

// //   const rightButtons = (
// //     <div className="d-flex align-items-center gap-3">
// //       {/* Big Attach Offer Letter Button */}
// //       <button
// //         onClick={handleAttachOfferLetter}
// //         disabled={isLoading || isSendingEmail || isAttaching}
// //         className="btn btn-primary btn-lg w-100 d-flex align-items-center justify-content-center gap-2"
// //         style={{
// //           backgroundColor: "#4f46e5",
// //           borderColor: "#4f46e5",
// //           padding: "12px 24px",
// //           fontSize: "1rem",
// //           fontWeight: 600
// //         }}
// //         title="Attach offer letter"
// //       >
// //         {isAttaching ? <Loader2 className="spinner-border spinner-border-sm" size={20} /> : <LinkIcon size={20} />}
// //         {isAttaching ? "Generating PDF..." : "Attach Offer Letter"}
// //       </button>
// //     </div>
// //   );

// //   return (
// //     <div className="vh-100 d-flex flex-column bg-light" style={{ backgroundColor: "#f8fafc" }}>
// //       {/* Add a hidden preview div for PDF generation */}
// //       <div style={{ position: 'fixed', top: '-10000px', left: '-10000px', visibility: 'hidden' }}>
// //         <div className="letter-preview-content">
// //           <LetterPreview
// //             state={state}
// //             selectedTemplate={activeTemplate}
// //             companyProfile={companyProfile}
// //           />
// //         </div>
// //       </div>

// //       {/* Main Content Grid */}
// //       <div className="flex-grow-1 w-100 p-4 overflow-hidden">
// //         <div className={`row g-4 h-100 ${!showPreview ? "justify-content-center" : ""}`}>

// //           {/* Left Form Column */}
// //           <div className={`${showPreview ? "col-lg-6 col-xl-7" : "col-lg-8 col-xl-6"} h-100 overflow-auto pe-2`} style={{ scrollbarWidth: "thin" }}>
// //             <div className="d-flex flex-column gap-4 pb-5">
// //               <RecipientCard
// //                 state={state}
// //                 updateState={updateState}
// //                 applicant={applicant}
// //                 errors={errors}
// //               />
// //               <LetterContentCard
// //                 state={state}
// //                 updateState={updateState}
// //                 applicant={applicant}
// //                 errors={errors}
// //               />
// //               <SignatureSettingsCard
// //                 state={state}
// //                 updateState={updateState}
// //                 openModal={() => setIsSignatureModalOpen(true)}
// //                 openESignModal={() => setIsESignModalOpen(true)}
// //               />
// //               <QrVerificationCard
// //                 templateState={qrCardState}
// //                 setTemplateState={handleQrCardUpdate}
// //                 errors={errors}
// //                 companyName={companyProfile?.name}
// //                 iquiqueCode={iquiqueCode}
// //               />
// //             </div>
// //             <div style={{ width: "100%", display: "flex", justifyContent: "space-evenly" }}>
// //               {rightButtons}
// //             </div>
// //           </div>

// //           {/* Right Preview Column */}
// //           {showPreview && (
// //             <div className="col-lg-6 col-xl-5 h-100 position-relative">
// //               <div className="bg-white rounded-3 border shadow-sm h-100 position-relative overflow-hidden">
// //                 {/* Fullscreen Button */}
// //                 <button
// //                   onClick={() => setIsFullscreenPreview(true)}
// //                   className="btn btn-light position-absolute top-0 end-0 m-3 rounded-circle shadow-sm d-flex align-items-center justify-content-center"
// //                   style={{ width: "38px", height: "38px", zIndex: 10 }}
// //                   title="Full Screen Preview"
// //                 >
// //                   <Maximize size={18} />
// //                 </button>

// //                 <div className="h-100 overflow-auto">
// //                   <div className="letter-preview-content bg-white">
// //                     <LetterPreview
// //                       state={state}
// //                       selectedTemplate={activeTemplate}
// //                       companyProfile={companyProfile}
// //                     />
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           )}
// //         </div>
// //       </div>

// //       {/* Signature Modal */}
// //       {isSignatureModalOpen && (
// //         <SignatureModal
// //           initialSignature={state.drawnSignature}
// //           onClose={() => setIsSignatureModalOpen(false)}
// //           onSave={(signatureData) => {
// //             updateState("drawnSignature", signatureData);
// //             setIsSignatureModalOpen(false);
// //           }}
// //         />
// //       )}

// //       {/* Aadhaar eSign Modal */}
// //       {isESignModalOpen && (
// //         <ESignModal
// //           onClose={() => setIsESignModalOpen(false)}
// //           onVerified={handleESignSuccess}
// //         />
// //       )}

// //       {/* Full Screen Preview Modal */}
// //       {isFullscreenPreview && (
// //         <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: "rgba(15, 23, 42, 0.6)", backdropFilter: "blur(4px)", zIndex: 1050 }}>
// //           <div className="bg-white rounded-4 shadow-lg d-flex flex-column" style={{ width: "90%", height: "90%", maxWidth: "1200px" }}>
// //             {/* Modal Header */}
// //             <div className="d-flex justify-content-between align-items-center p-4 border-bottom">
// //               <h5 className="fw-bold mb-0">Full Screen Preview</h5>
// //               <button
// //                 onClick={() => setIsFullscreenPreview(false)}
// //                 className="btn btn-link text-dark p-0"
// //                 style={{ fontSize: "1.5rem" }}
// //               >
// //                 <X size={24} />
// //               </button>
// //             </div>
// //             {/* Modal Body */}
// //             <div className="flex-grow-1 overflow-auto bg-light p-4">
// //               <LetterPreview
// //                 state={state}
// //                 selectedTemplate={activeTemplate}
// //                 companyProfile={companyProfile}
// //               />
// //             </div>
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // }

// import { useEffect, useMemo, useState } from "react";
// import { Eye, EyeOff, Loader2, Mail, Maximize, X, Link as LinkIcon, Save, Send } from "lucide-react";
// import { letterSchema, extractErrors } from "./services/letterValidationSchema.ts";
// import QrVerificationCard from "./components/letter/QrVerificationCard";
// import { ESignModal, LetterContentCard, LetterPreview, RecipientCard, SignatureModal, SignatureSettingsCard } from "./components/index.js";
// import { useLetterhead } from "./hooks/useLetterhead.ts";
// import { useLocation, useNavigate } from "react-router-dom";
// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';
// import { useDispatch, useSelector } from "react-redux";
// import { getTemplates } from "../../../Redux/Reducers/letterHeadReducer.ts";
// import { toast } from "react-toastify";
// import domtoimage from 'dom-to-image';
// // ─── IndexedDB helpers (Promise-based so we can await them cleanly) ──────────

// const openOfferLettersDB = () =>
//   new Promise((resolve, reject) => {
//     const req = indexedDB.open("OfferLettersDB", 1);
//     req.onupgradeneeded = (e) => {
//       const db = e.target.result;
//       if (!db.objectStoreNames.contains("pdfs")) {
//         db.createObjectStore("pdfs", { keyPath: "id" });
//       }
//     };
//     req.onsuccess = (e) => resolve(e.target.result);
//     req.onerror = (e) => reject(e.target.error);
//   });

// const putInDB = (db, data) =>
//   new Promise((resolve, reject) => {
//     const tx = db.transaction(["pdfs"], "readwrite");
//     tx.objectStore("pdfs").put(data);
//     tx.oncomplete = resolve;
//     tx.onerror = (e) => reject(e.target.error);
//   });

// // ─────────────────────────────────────────────────────────────────────────────

// export default function ComposeLetterPage() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const applicant = location.state?.applicant;
//   const applicationId = location.state?.applicationId;

//   const {
//     templates,
//     isLoading,
//     isEditMode,
//     companyProfile,
//     letterState: state,
//     updateLetterState: updateState,
//     processedTemplate,
//     isSignatureModalOpen,
//     setIsSignatureModalOpen,
//     isESignModalOpen,
//     setIsESignModalOpen,
//     handleSaveLetter: handleSave,
//     handleESignSuccess,
//     setLetterState,
//     iquiqueCode,
//     isSendingEmail,
//   } = useLetterhead();

//   const [errors, setErrors] = useState({});
//   const [showPreview, setShowPreview] = useState(true);
//   const [isFullscreenPreview, setIsFullscreenPreview] = useState(false);
//   const [isAttaching, setIsAttaching] = useState(false);

//   const selectedTemplateFromRedux = useSelector((state) => state.letterHead.template);
//   const ProfessionalExperience =
//     useSelector((state) => state?.ProfileArray?.experienceData?.data) || [];
//   const cid = ProfessionalExperience[0]?.companyDetails?.data[0]?.cid || "";
//   const activeTemplate = selectedTemplateFromRedux || processedTemplate;

//   const qrCardState = { ...state, subject: state.subjectQr };

//   useEffect(() => {
//     if (applicant?.role && !state.subject) {
//       updateState("subject", `Offer Letter for ${applicant.role} Position`);
//     }
//   }, [applicant?.role, state.subject, updateState]);

//   const handleQrCardUpdate = (updater) => {
//     setLetterState((prev) => {
//       const newState = typeof updater === "function" ? updater(prev) : updater;
//       if (newState.subject !== undefined && newState.subject !== prev.subject) {
//         return { ...newState, subjectQr: newState.subject, subject: prev.subject };
//       }
//       return newState;
//     });
//   };

//   // ─── PDF Generation ──────────────────────────────────────────────────────
//   //
//   // Captures every `.single-page` element from the hidden preview div.
//   // Each element is temporarily unscaled (transform: none) so html2canvas
//   // sees the full 794×1123px A4 size. Each page becomes one A4 PDF page.

//   // const generateAndSavePDF = async () => {
//   //   // The hidden preview div renders all pages at natural A4 scale
//   //   const pageEls = Array.from(
//   //     document.querySelectorAll(".pdf-capture-target .single-page")
//   //   );

//   //   if (pageEls.length === 0) {
//   //     // Fallback: capture the whole preview wrapper
//   //     const fallback = document.querySelector(".pdf-capture-target");
//   //     if (!fallback) {
//   //       throw new Error(
//   //         "Preview element not found — please wait a moment and try again."
//   //       );
//   //     }
//   //     pageEls.push(fallback);
//   //   }

//   //   const pdf = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait" });
//   //   const A4_W = 210;
//   //   const A4_H = 297;

//   //   for (let i = 0; i < pageEls.length; i++) {
//   //     const el = pageEls[i];

//   //     // Remove CSS scale so html2canvas captures at natural 794px width
//   //     const savedTransform    = el.style.transform;
//   //     const savedMarginBottom = el.style.marginBottom;
//   //     el.style.transform    = "none";
//   //     el.style.marginBottom = "0";

//   //     // eslint-disable-next-line no-await-in-loop
//   //     const canvas = await html2canvas(el, {
//   //       scale:       2,
//   //       useCORS:     true,
//   //       logging:     false,
//   //       backgroundColor: "#ffffff",
//   //       scrollX:     0,
//   //       scrollY:     0,
//   //       width:       el.offsetWidth,
//   //       height:      el.offsetHeight,
//   //       windowWidth: el.offsetWidth,
//   //       windowHeight: el.offsetHeight,
//   //     });

//   //     // Restore
//   //     el.style.transform    = savedTransform;
//   //     el.style.marginBottom = savedMarginBottom;

//   //     const imgData     = canvas.toDataURL("image/png");
//   //     const imgHeightMM = (canvas.height * A4_W) / canvas.width;

//   //     if (i > 0) pdf.addPage();

//   //     if (imgHeightMM > A4_H) {
//   //       const s = A4_H / imgHeightMM;
//   //       pdf.addImage(imgData, "PNG", 0, 0, A4_W * s, A4_H);
//   //     } else {
//   //       pdf.addImage(imgData, "PNG", 0, 0, A4_W, imgHeightMM);
//   //     }
//   //   }

//   //   return pdf;
//   // };

//   const generateAndSavePDF = async () => {
//     // Target the hidden PDF capture target specifically
//     const captureTarget = document.querySelector('.pdf-capture-target');

//     if (!captureTarget) {
//       throw new Error('PDF capture target not found - please wait for page to load');
//     }

//     // Get the content inside the capture target
//     const previewElement = captureTarget.querySelector('.letter-preview-content') || captureTarget;

//     if (!previewElement) {
//       throw new Error('Preview content not found');
//     }

//     // Clone so we don't disturb the UI
//     const element = previewElement.cloneNode(true);
//     element.style.width = '794px';
//     element.style.minHeight = '1122px';
//     element.style.maxHeight = 'none';
//     element.style.backgroundColor = '#ffffff';
//     element.style.position = 'fixed';
//     element.style.top = '0';
//     element.style.left = '-9999px';
//     element.style.visibility = 'visible';
//     element.style.display = 'block';
//     element.style.boxShadow = 'none';
//     element.style.overflow = 'visible';
//     document.body.appendChild(element);

//     // Wait for fonts to be ready (if supported)
//     if (document.fonts && document.fonts.ready) {
//       try {
//         await document.fonts.ready;
//       } catch (e) {
//         console.warn('Font loading failed:', e);
//       }
//     }

//     // Wait for images inside the clone to load
//     const imgs = element.querySelectorAll('img');
//     await Promise.all(Array.from(imgs).map(img => {
//       if (img.complete) return Promise.resolve();
//       return new Promise(res => {
//         img.onload = res;
//         img.onerror = res;
//       });
//     }));

//     // Wait for layout to settle
//     await new Promise(r => setTimeout(r, 500));

//     try {
//       // Convert to image
//       const svgDataUrl = await domtoimage.toPng(element, {
//         bgcolor: '#ffffff',
//         width: element.scrollWidth || 794,
//         height: element.scrollHeight || 1122,
//         style: {
//           transform: 'none',
//           margin: '0',
//           padding: '0'
//         },
//         cacheBust: true,
//       });

//       // Create PDF
//       const pdf = new jsPDF({
//         unit: 'mm',
//         format: 'a4',
//         orientation: 'portrait'
//       });

//       // Add image to PDF
//       const img = new Image();
//       img.src = svgDataUrl;

//       await new Promise((res, rej) => {
//         img.onload = res;
//         img.onerror = () => rej(new Error('Image failed to load'));
//       });

//       const imgWidth = 210; // A4 width in mm
//       const imgHeight = (img.height * imgWidth) / img.width;

//       // Add image with proper scaling for multiple pages if needed
//       pdf.addImage(svgDataUrl, 'PNG', 0, 0, imgWidth, imgHeight);

//       document.body.removeChild(element);
//       return pdf;
//     } catch (err) {
//       if (document.body.contains(element)) {
//         document.body.removeChild(element);
//       }
//       throw err;
//     }
//   };

//   // ─── Attach / Download ───────────────────────────────────────────────────

//   const handleAttachOfferLetter = async () => {
//     setIsAttaching(true);
//     try {
//       setErrors({});

//       const pdf = await generateAndSavePDF();
//       const fileName = `offer_letter_${applicationId || Date.now()}_${Date.now()}.pdf`;
//       const pdfBlob = pdf.output("blob");

//       // Trigger browser download
//       const url = URL.createObjectURL(pdfBlob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = fileName;
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);
//       setTimeout(() => URL.revokeObjectURL(url), 5000);

//       // Metadata (no binary — keeps localStorage small)
//       const letterMetadata = {
//         letterState: {
//           recipientEmail: state.recipientEmail,
//           recipientName: state.recipientName,
//           subject: `Offer Letter for ${applicant?.role} Position` || state.subject,
//           body: state.body,
//           closingNote: state.closingNote,
//           senderName: state.senderName,
//           senderDesignation: state.senderDesignation,
//           signatureType: state.signatureType,
//           isSigned: state.isSigned,
//           drawnSignature: state.drawnSignature ? "[SIGNATURE_PRESENT]" : null,
//         },
//         applicant: applicant ? { name: applicant.name, email: applicant.email, id: applicant.id } : null,
//         applicationId,
//         companyProfile: companyProfile ? { name: companyProfile.name, email: companyProfile.email } : null,
//         iquiqueCode,
//         timestamp: new Date().toISOString(),
//         generatedAt: new Date().toLocaleString(),
//         fileName,
//         fileSize: pdfBlob.size,
//         status: "attached",
//       };

//       // localStorage: metadata only
//       try {
//         localStorage.setItem("attachedOfferLetter", JSON.stringify(letterMetadata));
//         localStorage.setItem("lastOfferLetterId", fileName);
//       } catch (e) {
//         console.warn("localStorage quota exceeded:", e);
//       }

//       // sessionStorage: lightweight backup
//       try {
//         sessionStorage.setItem("lastOfferLetterMetadata", JSON.stringify({ ...letterMetadata, timestamp: Date.now() }));
//       } catch (e) {
//         console.warn("sessionStorage failed:", e);
//       }

//       // IndexedDB: await fully before navigating (fixes white-page race)
//       try {
//         const db = await openOfferLettersDB();
//         await putInDB(db, { id: fileName, pdfBlob, metadata: letterMetadata, timestamp: Date.now() });
//         console.log("PDF stored in IndexedDB successfully");
//       } catch (dbErr) {
//         console.warn("IndexedDB storage failed (download still succeeded):", dbErr);
//       }

//       toast.success("Offer letter generated and saved successfully!", {
//         position: "top-right",
//         autoClose: 3000,
//       });

//       // Navigate only after everything is committed
//       setTimeout(() => navigate(-1), 1500);
//     } catch (err) {
//       console.error("Error attaching offer letter:", err);
//       alert("Failed to generate PDF. Please try again.\n\n" + err.message);
//     } finally {
//       setIsAttaching(false);
//     }
//   };

//   const rightButtons = (
//     <div className="d-flex align-items-center gap-3">
//       <button
//         onClick={handleAttachOfferLetter}
//         disabled={isLoading || isSendingEmail || isAttaching}
//         className="btn btn-primary btn-lg w-100 d-flex align-items-center justify-content-center gap-2"
//         style={{
//           backgroundColor: "#4f46e5",
//           borderColor: "#4f46e5",
//           padding: "12px 24px",
//           fontSize: "1rem",
//           fontWeight: 600,
//         }}
//         title="Attach offer letter"
//       >
//         {isAttaching
//           ? <Loader2 className="spinner-border spinner-border-sm" size={20} />
//           : <LinkIcon size={20} />
//         }
//         {isAttaching ? "Generating PDF..." : "Attach Offer Letter"}
//       </button>
//     </div>
//   );

//   return (
//     <div className="vh-100 d-flex flex-column bg-light" style={{ backgroundColor: "#f8fafc" }}>

//       {/*
//         ── Hidden PDF-capture target ─────────────────────────────────────────
//         Renders all letter pages at SCALE=1 (natural A4 size) so html2canvas
//         captures crisp full-resolution pages.

//         Key points:
//         - position:fixed + off-screen keeps it out of layout flow
//         - visibility:hidden hides it from user but html2canvas still reads it
//         - overflow:visible so all pages stack vertically and are all captured
//         - pdf-capture-target class is the querySelector hook in generateAndSavePDF
//       */}
//       <div
//         className="pdf-capture-target"
//         style={{
//           position: "fixed",
//           top: "-9999px",      // Changed from -99999px
//           left: "-9999px",     // Changed from -99999px  
//           visibility: "hidden",
//           overflow: "visible",
//           zIndex: -1,
//           width: "794px",      // Added explicit width
//           minHeight: "1122px", // Added explicit height
//         }}
//       >
//         <LetterPreview
//           state={state}
//           selectedTemplate={activeTemplate}
//           companyProfile={companyProfile}
//           forcedScale={1}         // tell LetterPreview to render pages at scale=1
//         />
//       </div>

//       {/* ── Main Content Grid ─────────────────────────────────────────────── */}
//       <div className="flex-grow-1 w-100 p-4 overflow-hidden">
//         <div className={`row g-4 h-100 ${!showPreview ? "justify-content-center" : ""}`}>

//           {/* Left: Form column */}
//           <div
//             className={`${showPreview ? "col-lg-6 col-xl-7" : "col-lg-8 col-xl-6"} h-100 overflow-auto pe-2`}
//             style={{ scrollbarWidth: "thin" }}
//           >
//             <div className="d-flex flex-column gap-4 pb-5">
//               <RecipientCard
//                 state={state}
//                 updateState={updateState}
//                 applicant={applicant}
//                 errors={errors}
//               />
//               <LetterContentCard
//                 state={state}
//                 updateState={updateState}
//                 applicant={applicant}
//                 errors={errors}
//               />
//               <SignatureSettingsCard
//                 state={state}
//                 updateState={updateState}
//                 openModal={() => setIsSignatureModalOpen(true)}
//                 openESignModal={() => setIsESignModalOpen(true)}
//               />
//               <QrVerificationCard
//                 templateState={qrCardState}
//                 setTemplateState={handleQrCardUpdate}
//                 errors={errors}
//                 companyName={companyProfile?.name}
//                 iquiqueCode={iquiqueCode}
//               />
//             </div>
//             <div style={{ width: "100%", display: "flex", justifyContent: "space-evenly" }}>
//               {rightButtons}
//             </div>
//           </div>

//           {/* Right: Preview column */}
//           {showPreview && (
//             <div className="col-lg-6 col-xl-5 h-100 position-relative">
//               <div className="bg-white rounded-3 border shadow-sm h-100 position-relative overflow-hidden">
//                 <button
//                   onClick={() => setIsFullscreenPreview(true)}
//                   className="btn btn-light position-absolute top-0 end-0 m-3 rounded-circle shadow-sm d-flex align-items-center justify-content-center"
//                   style={{ width: "38px", height: "38px", zIndex: 10 }}
//                   title="Full Screen Preview"
//                 >
//                   <Maximize size={18} />
//                 </button>

//                 <div className="h-100 overflow-auto">
//                   <div className="letter-preview-content bg-white">
//                     <LetterPreview
//                       state={state}
//                       selectedTemplate={activeTemplate}
//                       companyProfile={companyProfile}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Signature Modal */}
//       {isSignatureModalOpen && (
//         <SignatureModal
//           initialSignature={state.drawnSignature}
//           onClose={() => setIsSignatureModalOpen(false)}
//           onSave={(signatureData) => {
//             updateState("drawnSignature", signatureData);
//             setIsSignatureModalOpen(false);
//           }}
//         />
//       )}

//       {/* eSign Modal */}
//       {isESignModalOpen && (
//         <ESignModal
//           onClose={() => setIsESignModalOpen(false)}
//           onVerified={handleESignSuccess}
//         />
//       )}

//       {/* Full Screen Preview Modal */}
//       {isFullscreenPreview && (
//         <div
//           className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
//           style={{ backgroundColor: "rgba(15,23,42,0.6)", backdropFilter: "blur(4px)", zIndex: 1050 }}
//         >
//           <div
//             className="bg-white rounded-4 shadow-lg d-flex flex-column"
//             style={{ width: "90%", height: "90%", maxWidth: "1200px" }}
//           >
//             <div className="d-flex justify-content-between align-items-center p-4 border-bottom">
//               <h5 className="fw-bold mb-0">Full Screen Preview</h5>
//               <button
//                 onClick={() => setIsFullscreenPreview(false)}
//                 className="btn btn-link text-dark p-0"
//                 style={{ fontSize: "1.5rem" }}
//               >
//                 <X size={24} />
//               </button>
//             </div>
//             <div className="flex-grow-1 overflow-auto bg-light p-4">
//               <LetterPreview
//                 state={state}
//                 selectedTemplate={activeTemplate}
//                 companyProfile={companyProfile}
//               />
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// import { useEffect, useMemo, useState } from "react";
// import { Eye, EyeOff, Loader2, Mail, Maximize, X, Link as LinkIcon, Save, Send } from "lucide-react";
// import { letterSchema, extractErrors } from "./services/letterValidationSchema.ts";
// import QrVerificationCard from "./components/letter/QrVerificationCard";
// import { ESignModal, LetterContentCard, LetterPreview, RecipientCard, SignatureModal, SignatureSettingsCard } from "./components/index.js";
// import { useLetterhead } from "./hooks/useLetterhead.ts";
// import { useLocation, useNavigate } from "react-router-dom";
// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';
// import { useDispatch, useSelector } from "react-redux";
// import { getTemplates } from "../../../Redux/Reducers/letterHeadReducer.ts";
// import { toast } from "react-toastify";

// // ─── IndexedDB helpers ──────────────────────────────────────────
// const openOfferLettersDB = () =>
//   new Promise((resolve, reject) => {
//     const req = indexedDB.open("OfferLettersDB", 1);
//     req.onupgradeneeded = (e) => {
//       const db = e.target.result;
//       if (!db.objectStoreNames.contains("pdfs")) {
//         db.createObjectStore("pdfs", { keyPath: "id" });
//       }
//     };
//     req.onsuccess = (e) => resolve(e.target.result);
//     req.onerror = (e) => reject(e.target.error);
//   });

// const putInDB = (db, data) =>
//   new Promise((resolve, reject) => {
//     const tx = db.transaction(["pdfs"], "readwrite");
//     tx.objectStore("pdfs").put(data);
//     tx.oncomplete = resolve;
//     tx.onerror = (e) => reject(e.target.error);
//   });

// // ─────────────────────────────────────────────────────────────────

// export default function ComposeLetterPage() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const applicant = location.state?.applicant;
//   const applicationId = location.state?.applicationId;

//   const {
//     templates,
//     isLoading,
//     isEditMode,
//     companyProfile,
//     letterState: state,
//     updateLetterState: updateState,
//     processedTemplate,
//     isSignatureModalOpen,
//     setIsSignatureModalOpen,
//     isESignModalOpen,
//     setIsESignModalOpen,
//     handleSaveLetter: handleSave,
//     handleESignSuccess,
//     setLetterState,
//     iquiqueCode,
//     isSendingEmail,
//   } = useLetterhead();

//   const [errors, setErrors] = useState({});
//   const [showPreview, setShowPreview] = useState(true);
//   const [isFullscreenPreview, setIsFullscreenPreview] = useState(false);
//   const [isAttaching, setIsAttaching] = useState(false);
//   const [pdfGenerationError, setPdfGenerationError] = useState(null);

//   const selectedTemplateFromRedux = useSelector((state) => state.letterHead.template);
//   const ProfessionalExperience =
//     useSelector((state) => state?.ProfileArray?.experienceData?.data) || [];
//   const cid = ProfessionalExperience[0]?.companyDetails?.data[0]?.cid || "";
//   const activeTemplate = selectedTemplateFromRedux || processedTemplate;

//   const qrCardState = { ...state, subject: state.subjectQr };

//   useEffect(() => {
//     if (applicant?.role && !state.subject) {
//       updateState("subject", `Offer Letter for ${applicant.role} Position`);
//     }
//   }, [applicant?.role, state.subject, updateState]);

//   const handleQrCardUpdate = (updater) => {
//     setLetterState((prev) => {
//       const newState = typeof updater === "function" ? updater(prev) : updater;
//       if (newState.subject !== undefined && newState.subject !== prev.subject) {
//         return { ...newState, subjectQr: newState.subject, subject: prev.subject };
//       }
//       return newState;
//     });
//   };

//   // ─── IMPROVED PDF Generation with html2canvas (more reliable for signed content) ───
//   const generateAndSavePDF = async () => {
//     // Get the main preview element that's visible to the user
//     // This ensures we capture the exact state including signatures
//     const previewContainer = document.querySelector('.letter-preview-content');
    
//     if (!previewContainer) {
//       throw new Error('Preview content not found - please make sure the letter preview is visible');
//     }

//     // Find all page elements within the preview
//     const pageElements = previewContainer.querySelectorAll('.single-page');
    
//     if (pageElements.length === 0) {
//       throw new Error('No letter pages found to capture');
//     }

//     // Create a temporary container for capturing
//     const tempContainer = document.createElement('div');
//     tempContainer.style.position = 'fixed';
//     tempContainer.style.top = '-9999px';
//     tempContainer.style.left = '-9999px';
//     tempContainer.style.width = 'auto';
//     tempContainer.style.height = 'auto';
//     tempContainer.style.backgroundColor = '#ffffff';
//     tempContainer.style.zIndex = '-1';
//     document.body.appendChild(tempContainer);

//     // Clone all pages and add to temp container
//     const clonedPages = [];
//     for (let i = 0; i < pageElements.length; i++) {
//       const originalPage = pageElements[i];
//       const clone = originalPage.cloneNode(true);
      
//       // Ensure clone has correct dimensions
//       clone.style.transform = 'none';
//       clone.style.margin = '0';
//       clone.style.position = 'relative';
//       clone.style.top = 'auto';
//       clone.style.left = 'auto';
//       clone.style.overflow = 'hidden';
//       clone.style.boxShadow = 'none';
//       clone.style.backgroundColor = '#ffffff';
      
//       // Preserve the exact dimensions
//       const width = originalPage.offsetWidth;
//       const height = originalPage.offsetHeight;
//       clone.style.width = `${width}px`;
//       clone.style.height = `${height}px`;
//       clone.style.minWidth = `${width}px`;
//       clone.style.minHeight = `${height}px`;
      
//       tempContainer.appendChild(clone);
//       clonedPages.push(clone);
//     }

//     // Wait for any images to load in clones
//     await new Promise((resolve) => setTimeout(resolve, 300));
    
//     // Wait for fonts
//     if (document.fonts && document.fonts.ready) {
//       try {
//         await document.fonts.ready;
//       } catch (e) {
//         console.warn('Font loading warning:', e);
//       }
//     }

//     // Wait for images in clones
//     const allImages = tempContainer.querySelectorAll('img');
//     await Promise.all(
//       Array.from(allImages).map(
//         (img) =>
//           new Promise((resolve) => {
//             if (img.complete && img.naturalHeight !== 0) {
//               resolve();
//             } else {
//               img.onload = resolve;
//               img.onerror = resolve;
//               setTimeout(resolve, 1000);
//             }
//           })
//       )
//     );

//     try {
//       const pdf = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait" });
//       const A4_W = 210;
//       const A4_H = 297;

//       for (let i = 0; i < clonedPages.length; i++) {
//         const page = clonedPages[i];
        
//         // Capture with html2canvas (more reliable than dom-to-image)
//         const canvas = await html2canvas(page, {
//           scale: 2.5, // Higher scale for better quality
//           useCORS: true,
//           logging: false,
//           backgroundColor: "#ffffff",
//           allowTaint: false,
//           foreignObjectRendering: false,
//           onclone: (clonedDoc, element) => {
//             // Ensure styles are properly applied in the cloned context
//             element.style.overflow = 'hidden';
//           }
//         });

//         const imgData = canvas.toDataURL("image/png");
//         const imgWidth = A4_W;
//         const imgHeight = (canvas.height * imgWidth) / canvas.width;

//         if (i > 0) {
//           pdf.addPage();
//         }

//         // Add image to PDF
//         if (imgHeight <= A4_H) {
//           pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
//         } else {
//           // If image is taller than A4, scale to fit
//           const scaleRatio = A4_H / imgHeight;
//           pdf.addImage(imgData, "PNG", 0, 0, imgWidth * scaleRatio, A4_H);
//         }
//       }

//       // Clean up
//       document.body.removeChild(tempContainer);
      
//       return pdf;
//     } catch (error) {
//       // Clean up on error
//       if (document.body.contains(tempContainer)) {
//         document.body.removeChild(tempContainer);
//       }
//       throw error;
//     }
//   };

//   // ─── Alternative method using the hidden div (fallback) ───
//   const generatePDFFromHiddenTarget = async () => {
//     const captureTarget = document.querySelector('.pdf-capture-target');
    
//     if (!captureTarget) {
//       throw new Error('PDF capture target not found');
//     }

//     const pages = captureTarget.querySelectorAll('.single-page');
    
//     if (pages.length === 0) {
//       throw new Error('No pages found in capture target');
//     }

//     // Temporarily make hidden div visible for capture
//     const originalVisibility = captureTarget.style.visibility;
//     const originalTop = captureTarget.style.top;
//     const originalLeft = captureTarget.style.left;
    
//     captureTarget.style.visibility = 'visible';
//     captureTarget.style.top = '0';
//     captureTarget.style.left = '0';
//     captureTarget.style.position = 'fixed';
//     captureTarget.style.zIndex = '-1';
    
//     await new Promise(resolve => setTimeout(resolve, 100));

//     const pdf = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait" });
//     const A4_W = 210;

//     for (let i = 0; i < pages.length; i++) {
//       const canvas = await html2canvas(pages[i], {
//         scale: 2.5,
//         useCORS: true,
//         backgroundColor: "#ffffff",
//       });
      
//       const imgData = canvas.toDataURL("image/png");
//       const imgHeight = (canvas.height * A4_W) / canvas.width;
      
//       if (i > 0) pdf.addPage();
//       pdf.addImage(imgData, "PNG", 0, 0, A4_W, imgHeight);
//     }
    
//     // Restore hidden styles
//     captureTarget.style.visibility = originalVisibility;
//     captureTarget.style.top = originalTop;
//     captureTarget.style.left = originalLeft;
    
//     return pdf;
//   };

//   // ─── Attach / Download with retry logic ───
//   const handleAttachOfferLetter = async () => {
//     setIsAttaching(true);
//     setPdfGenerationError(null);
    
//     // Show loading toast
//     const loadingToast = toast.loading("Generating PDF, please wait...", {
//       position: "top-right",
//     });
    
//     try {
//       setErrors({});

//       // First try the main preview method (captures signatures correctly)
//       let pdf;
//       let useFallback = false;
      
//       try {
//         pdf = await generateAndSavePDF();
//         console.log("PDF generated successfully using main preview method");
//       } catch (mainError) {
//         console.warn("Main PDF generation failed, trying fallback:", mainError);
//         useFallback = true;
        
//         try {
//           pdf = await generatePDFFromHiddenTarget();
//           console.log("PDF generated successfully using fallback method");
//         } catch (fallbackError) {
//           throw new Error(`Both PDF generation methods failed. Main: ${mainError.message}, Fallback: ${fallbackError.message}`);
//         }
//       }

//       const fileName = `offer_letter_${applicationId || Date.now()}_${Date.now()}.pdf`;
//       const pdfBlob = pdf.output("blob");

//       // Trigger browser download
//       const url = URL.createObjectURL(pdfBlob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = fileName;
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);
      
//       // Revoke URL after a delay
//       setTimeout(() => URL.revokeObjectURL(url), 10000);

//       // Metadata for storage (no binary data)
//       const letterMetadata = {
//         letterState: {
//           recipientEmail: state.recipientEmail,
//           recipientName: state.recipientName,
//           subject: `Offer Letter for ${applicant?.role} Position` || state.subject,
//           body: state.body,
//           closingNote: state.closingNote,
//           senderName: state.senderName,
//           senderDesignation: state.senderDesignation,
//           signatureType: state.signatureType,
//           isSigned: state.isSigned,
//           drawnSignature: state.drawnSignature ? "[SIGNATURE_PRESENT]" : null,
//           uploadedSignature: state.uploadedSignatureUrl ? "[SIGNATURE_PRESENT]" : null,
//         },
//         applicant: applicant ? { name: applicant.name, email: applicant.email, id: applicant.id } : null,
//         applicationId,
//         companyProfile: companyProfile ? { name: companyProfile.name, email: companyProfile.email } : null,
//         iquiqueCode,
//         timestamp: new Date().toISOString(),
//         generatedAt: new Date().toLocaleString(),
//         fileName,
//         fileSize: pdfBlob.size,
//         status: "attached",
//       };

//       // Store in localStorage (metadata only)
//       try {
//         localStorage.setItem("attachedOfferLetter", JSON.stringify(letterMetadata));
//         localStorage.setItem("lastOfferLetterId", fileName);
//       } catch (e) {
//         console.warn("localStorage quota exceeded:", e);
//       }

//       // Store in sessionStorage as backup
//       try {
//         sessionStorage.setItem("lastOfferLetterMetadata", JSON.stringify({ ...letterMetadata, timestamp: Date.now() }));
//       } catch (e) {
//         console.warn("sessionStorage failed:", e);
//       }

//       // Store in IndexedDB (with actual blob for potential future retrieval)
//       try {
//         const db = await openOfferLettersDB();
//         await putInDB(db, { 
//           id: fileName, 
//           pdfBlob, 
//           metadata: letterMetadata, 
//           timestamp: Date.now() 
//         });
//         console.log("PDF stored in IndexedDB successfully");
//       } catch (dbErr) {
//         console.warn("IndexedDB storage failed (download still succeeded):", dbErr);
//       }

//       // Update toast to success
//       toast.update(loadingToast, {
//         render: "Offer letter generated and saved successfully!",
//         type: "success",
//         isLoading: false,
//         autoClose: 3000,
//       });

//       // Navigate after a short delay
//       setTimeout(() => navigate(-1), 1500);
      
//     } catch (err) {
//       console.error("Error attaching offer letter:", err);
      
//       toast.update(loadingToast, {
//         render: `Failed to generate PDF: ${err.message}`,
//         type: "error",
//         isLoading: false,
//         autoClose: 5000,
//       });
      
//       setPdfGenerationError(err.message);
//     } finally {
//       setIsAttaching(false);
//     }
//   };

//   const rightButtons = (
//     <div className="d-flex align-items-center gap-3">
//       <button
//         onClick={handleAttachOfferLetter}
//         disabled={isLoading || isSendingEmail || isAttaching}
//         className="btn btn-primary btn-lg w-100 d-flex align-items-center justify-content-center gap-2"
//         style={{
//           backgroundColor: "#4f46e5",
//           borderColor: "#4f46e5",
//           padding: "12px 24px",
//           fontSize: "1rem",
//           fontWeight: 600,
//         }}
//         title="Attach offer letter"
//       >
//         {isAttaching
//           ? <Loader2 className="spinner-border spinner-border-sm" size={20} />
//           : <LinkIcon size={20} />
//         }
//         {isAttaching ? "Generating PDF..." : "Attach Offer Letter"}
//       </button>
//     </div>
//   );

//   // Show error message if PDF generation failed
//   const ErrorDisplay = pdfGenerationError && (
//     <div className="alert alert-danger mt-3" role="alert">
//       <strong>PDF Generation Error:</strong> {pdfGenerationError}
//       <br />
//       <small>Please try refreshing the page and ensure all content is loaded before attaching.</small>
//     </div>
//   );

//   return (
//     <div className="vh-100 d-flex flex-column bg-light" style={{ backgroundColor: "#f8fafc" }}>

//       {/* 
//         Hidden PDF-capture target - kept as fallback
//       */}
//       <div
//         className="pdf-capture-target"
//         style={{
//           position: "fixed",
//           top: "-99999px",
//           left: "-99999px",
//           visibility: "hidden",
//           overflow: "visible",
//           zIndex: -1,
//           width: "auto",
//         }}
//       >
//         <LetterPreview
//           state={state}
//           selectedTemplate={activeTemplate}
//           companyProfile={companyProfile}
//         />
//       </div>

//       {/* Main Content Grid */}
//       <div className="flex-grow-1 w-100 p-4 overflow-hidden">
//         <div className={`row g-4 h-100 ${!showPreview ? "justify-content-center" : ""}`}>

//           {/* Left: Form column */}
//           <div
//             className={`${showPreview ? "col-lg-6 col-xl-7" : "col-lg-8 col-xl-6"} h-100 overflow-auto pe-2`}
//             style={{ scrollbarWidth: "thin" }}
//           >
//             <div className="d-flex flex-column gap-4 pb-5">
//               <RecipientCard
//                 state={state}
//                 updateState={updateState}
//                 applicant={applicant}
//                 errors={errors}
//               />
//               <LetterContentCard
//                 state={state}
//                 updateState={updateState}
//                 applicant={applicant}
//                 errors={errors}
//               />
//               <SignatureSettingsCard
//                 state={state}
//                 updateState={updateState}
//                 openModal={() => setIsSignatureModalOpen(true)}
//                 openESignModal={() => setIsESignModalOpen(true)}
//               />
//               <QrVerificationCard
//                 templateState={qrCardState}
//                 setTemplateState={handleQrCardUpdate}
//                 errors={errors}
//                 companyName={companyProfile?.name}
//                 iquiqueCode={iquiqueCode}
//               />
//             </div>
//             <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "1rem" }}>
//               {rightButtons}
//               {ErrorDisplay}
//             </div>
//           </div>

//           {/* Right: Preview column */}
//           {showPreview && (
//             <div className="col-lg-6 col-xl-5 h-100 position-relative">
//               <div className="bg-white rounded-3 border shadow-sm h-100 position-relative overflow-hidden">
//                 <button
//                   onClick={() => setIsFullscreenPreview(true)}
//                   className="btn btn-light position-absolute top-0 end-0 m-3 rounded-circle shadow-sm d-flex align-items-center justify-content-center"
//                   style={{ width: "38px", height: "38px", zIndex: 10 }}
//                   title="Full Screen Preview"
//                 >
//                   <Maximize size={18} />
//                 </button>

//                 <div className="h-100 overflow-auto">
//                   <div className="letter-preview-content bg-white">
//                     <LetterPreview
//                       state={state}
//                       selectedTemplate={activeTemplate}
//                       companyProfile={companyProfile}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Signature Modal */}
//       {isSignatureModalOpen && (
//         <SignatureModal
//           initialSignature={state.drawnSignature}
//           onClose={() => setIsSignatureModalOpen(false)}
//           onSave={(signatureData) => {
//             updateState("drawnSignature", signatureData);
//             setIsSignatureModalOpen(false);
//           }}
//         />
//       )}

//       {/* eSign Modal */}
//       {isESignModalOpen && (
//         <ESignModal
//           onClose={() => setIsESignModalOpen(false)}
//           onVerified={handleESignSuccess}
//         />
//       )}

//       {/* Full Screen Preview Modal */}
//       {isFullscreenPreview && (
//         <div
//           className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
//           style={{ backgroundColor: "rgba(15,23,42,0.6)", backdropFilter: "blur(4px)", zIndex: 1050 }}
//         >
//           <div
//             className="bg-white rounded-4 shadow-lg d-flex flex-column"
//             style={{ width: "90%", height: "90%", maxWidth: "1200px" }}
//           >
//             <div className="d-flex justify-content-between align-items-center p-4 border-bottom">
//               <h5 className="fw-bold mb-0">Full Screen Preview</h5>
//               <button
//                 onClick={() => setIsFullscreenPreview(false)}
//                 className="btn btn-link text-dark p-0"
//                 style={{ fontSize: "1.5rem" }}
//               >
//                 <X size={24} />
//               </button>
//             </div>
//             <div className="flex-grow-1 overflow-auto bg-light p-4">
//               <LetterPreview
//                 state={state}
//                 selectedTemplate={activeTemplate}
//                 companyProfile={companyProfile}
//               />
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// import { useEffect, useMemo, useState } from "react";
// import { Eye, EyeOff, Loader2, Mail, Maximize, X, Link as LinkIcon, Save, Send } from "lucide-react";
// import { letterSchema, extractErrors } from "./services/letterValidationSchema.ts";
// import QrVerificationCard from "./components/letter/QrVerificationCard";
// import { ESignModal, LetterContentCard, LetterPreview, RecipientCard, SignatureModal, SignatureSettingsCard } from "./components/index.js";
// import { useLetterhead } from "./hooks/useLetterhead.ts";
// import { useLocation, useNavigate } from "react-router-dom";
// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';
// import { useDispatch, useSelector } from "react-redux";
// import { getTemplates } from "../../../Redux/Reducers/letterHeadReducer.ts";
// import { toast } from "react-toastify";

// // ─── IndexedDB helpers ──────────────────────────────────────────
// const openOfferLettersDB = () =>
//   new Promise((resolve, reject) => {
//     const req = indexedDB.open("OfferLettersDB", 1);
//     req.onupgradeneeded = (e) => {
//       const db = e.target.result;
//       if (!db.objectStoreNames.contains("pdfs")) {
//         db.createObjectStore("pdfs", { keyPath: "id" });
//       }
//     };
//     req.onsuccess = (e) => resolve(e.target.result);
//     req.onerror = (e) => reject(e.target.error);
//   });

// const putInDB = (db, data) =>
//   new Promise((resolve, reject) => {
//     const tx = db.transaction(["pdfs"], "readwrite");
//     tx.objectStore("pdfs").put(data);
//     tx.oncomplete = resolve;
//     tx.onerror = (e) => reject(e.target.error);
//   });

// // ─── Helper to convert image to base64 to bypass CORS ──────────
// const imageToBase64 = (url) => {
//   return new Promise((resolve, reject) => {
//     if (!url) {
//       resolve(null);
//       return;
//     }
    
//     const img = new Image();
//     img.crossOrigin = "Anonymous"; // Important for CORS
    
//     img.onload = () => {
//       const canvas = document.createElement('canvas');
//       canvas.width = img.width;
//       canvas.height = img.height;
//       const ctx = canvas.getContext('2d');
//       ctx.drawImage(img, 0, 0);
//       resolve(canvas.toDataURL('image/png'));
//     };
    
//     img.onerror = () => {
//       console.warn(`Failed to load image: ${url}`);
//       resolve(null);
//     };
    
//     // Add timestamp to avoid cache issues
//     img.src = url + (url.includes('?') ? '&_t=' : '?_t=') + Date.now();
//   });
// };

// // ─── Convert all images in an element to base64 ────────────────
// const convertImagesToBase64 = async (element) => {
//   const images = element.querySelectorAll('img');
//   const conversions = [];
  
//   for (const img of images) {
//     const originalSrc = img.src;
//     if (originalSrc && !originalSrc.startsWith('data:')) {
//       conversions.push(
//         imageToBase64(originalSrc).then(base64 => {
//           if (base64) {
//             img.src = base64;
//           }
//         }).catch(err => {
//           console.warn(`Failed to convert image: ${originalSrc}`, err);
//         })
//       );
//     }
//   }
  
//   await Promise.all(conversions);
//   return element;
// };

// // ─────────────────────────────────────────────────────────────────

// export default function ComposeLetterPage() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const applicant = location.state?.applicant;
//   const applicationId = location.state?.applicationId;

//   const {
//     templates,
//     isLoading,
//     isEditMode,
//     companyProfile,
//     letterState: state,
//     updateLetterState: updateState,
//     processedTemplate,
//     isSignatureModalOpen,
//     setIsSignatureModalOpen,
//     isESignModalOpen,
//     setIsESignModalOpen,
//     handleSaveLetter: handleSave,
//     handleESignSuccess,
//     setLetterState,
//     iquiqueCode,
//     isSendingEmail,
//   } = useLetterhead();

//   const [errors, setErrors] = useState({});
//   const [showPreview, setShowPreview] = useState(true);
//   const [isFullscreenPreview, setIsFullscreenPreview] = useState(false);
//   const [isAttaching, setIsAttaching] = useState(false);
//   const [pdfGenerationError, setPdfGenerationError] = useState(null);

//   const selectedTemplateFromRedux = useSelector((state) => state.letterHead.template);
//   const ProfessionalExperience =
//     useSelector((state) => state?.ProfileArray?.experienceData?.data) || [];
//   const cid = ProfessionalExperience[0]?.companyDetails?.data[0]?.cid || "";
//   const activeTemplate = selectedTemplateFromRedux || processedTemplate;

//   const qrCardState = { ...state, subject: state.subjectQr };

//   useEffect(() => {
//     if (applicant?.role && !state.subject) {
//       updateState("subject", `Offer Letter for ${applicant.role} Position`);
//     }
//   }, [applicant?.role, state.subject, updateState]);

//   const handleQrCardUpdate = (updater) => {
//     setLetterState((prev) => {
//       const newState = typeof updater === "function" ? updater(prev) : updater;
//       if (newState.subject !== undefined && newState.subject !== prev.subject) {
//         return { ...newState, subjectQr: newState.subject, subject: prev.subject };
//       }
//       return newState;
//     });
//   };

//   // ─── PDF Generation with CORS fix ─────────────────────────────
//   const generateAndSavePDF = async () => {
//     // Get the main preview element
//     const previewContainer = document.querySelector('.letter-preview-content');
    
//     if (!previewContainer) {
//       throw new Error('Preview content not found');
//     }

//     // Find all page elements
//     const pageElements = previewContainer.querySelectorAll('.single-page');
    
//     if (pageElements.length === 0) {
//       throw new Error('No letter pages found to capture');
//     }

//     // Create a temporary container for capturing
//     const tempContainer = document.createElement('div');
//     tempContainer.style.position = 'fixed';
//     tempContainer.style.top = '-9999px';
//     tempContainer.style.left = '-9999px';
//     tempContainer.style.width = 'auto';
//     tempContainer.style.height = 'auto';
//     tempContainer.style.backgroundColor = '#ffffff';
//     tempContainer.style.zIndex = '-1';
//     document.body.appendChild(tempContainer);

//     // Clone all pages and convert images to base64 to bypass CORS
//     const clonedPages = [];
//     for (let i = 0; i < pageElements.length; i++) {
//       const originalPage = pageElements[i];
//       const clone = originalPage.cloneNode(true);
      
//       // Ensure clone has correct dimensions
//       clone.style.transform = 'none';
//       clone.style.margin = '0';
//       clone.style.position = 'relative';
//       clone.style.top = 'auto';
//       clone.style.left = 'auto';
//       clone.style.overflow = 'hidden';
//       clone.style.boxShadow = 'none';
//       clone.style.backgroundColor = '#ffffff';
      
//       // Preserve dimensions
//       const width = originalPage.offsetWidth;
//       const height = originalPage.offsetHeight;
//       clone.style.width = `${width}px`;
//       clone.style.height = `${height}px`;
//       clone.style.minWidth = `${width}px`;
//       clone.style.minHeight = `${height}px`;
      
//       tempContainer.appendChild(clone);
      
//       // Convert images to base64 in the clone BEFORE html2canvas runs
//       await convertImagesToBase64(clone);
      
//       clonedPages.push(clone);
//     }

//     // Wait for any remaining fonts/styles
//     await new Promise((resolve) => setTimeout(resolve, 500));
    
//     // Wait for fonts if available
//     if (document.fonts && document.fonts.ready) {
//       try {
//         await document.fonts.ready;
//       } catch (e) {
//         console.warn('Font loading warning:', e);
//       }
//     }

//     try {
//       const pdf = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait" });
//       const A4_W = 210;
//       const A4_H = 297;

//       for (let i = 0; i < clonedPages.length; i++) {
//         const page = clonedPages[i];
        
//         // Capture with html2canvas - CORS issues should be resolved since images are now base64
//         const canvas = await html2canvas(page, {
//           scale: 2.5,
//           useCORS: true,
//           logging: false,
//           backgroundColor: "#ffffff",
//           allowTaint: false,
//           foreignObjectRendering: false,
//           onclone: (clonedDoc, element) => {
//             // Ensure styles are properly applied in the cloned context
//             element.style.overflow = 'hidden';
//           }
//         });

//         const imgData = canvas.toDataURL("image/png");
//         const imgWidth = A4_W;
//         const imgHeight = (canvas.height * imgWidth) / canvas.width;

//         if (i > 0) {
//           pdf.addPage();
//         }

//         if (imgHeight <= A4_H) {
//           pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
//         } else {
//           const scaleRatio = A4_H / imgHeight;
//           pdf.addImage(imgData, "PNG", 0, 0, imgWidth * scaleRatio, A4_H);
//         }
//       }

//       // Clean up
//       document.body.removeChild(tempContainer);
      
//       return pdf;
//     } catch (error) {
//       if (document.body.contains(tempContainer)) {
//         document.body.removeChild(tempContainer);
//       }
//       throw error;
//     }
//   };

//   // ─── Alternative method using SVG render (works better with CORS) ───
//   const generatePDFFromHiddenTarget = async () => {
//     const captureTarget = document.querySelector('.pdf-capture-target');
    
//     if (!captureTarget) {
//       throw new Error('PDF capture target not found');
//     }

//     const pages = captureTarget.querySelectorAll('.single-page');
    
//     if (pages.length === 0) {
//       throw new Error('No pages found in capture target');
//     }

//     // Create a clone and convert images to base64
//     const tempContainer = document.createElement('div');
//     tempContainer.style.position = 'fixed';
//     tempContainer.style.top = '-9999px';
//     tempContainer.style.left = '-9999px';
//     tempContainer.style.visibility = 'visible';
//     tempContainer.style.backgroundColor = '#ffffff';
//     document.body.appendChild(tempContainer);

//     const clonedPages = [];
//     for (let i = 0; i < pages.length; i++) {
//       const clone = pages[i].cloneNode(true);
//       clone.style.transform = 'none';
//       clone.style.margin = '0';
//       clone.style.position = 'relative';
//       clone.style.boxShadow = 'none';
//       tempContainer.appendChild(clone);
//       await convertImagesToBase64(clone);
//       clonedPages.push(clone);
//     }

//     await new Promise(resolve => setTimeout(resolve, 300));

//     const pdf = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait" });
//     const A4_W = 210;

//     for (let i = 0; i < clonedPages.length; i++) {
//       const canvas = await html2canvas(clonedPages[i], {
//         scale: 2.5,
//         useCORS: true,
//         backgroundColor: "#ffffff",
//         logging: false,
//       });
      
//       const imgData = canvas.toDataURL("image/png");
//       const imgHeight = (canvas.height * A4_W) / canvas.width;
      
//       if (i > 0) pdf.addPage();
//       pdf.addImage(imgData, "PNG", 0, 0, A4_W, imgHeight);
//     }
    
//     document.body.removeChild(tempContainer);
//     return pdf;
//   };

//   // ─── Attach / Download with retry logic ───
//   const handleAttachOfferLetter = async () => {
//     setIsAttaching(true);
//     setPdfGenerationError(null);
    
//     const loadingToast = toast.loading("Generating PDF, please wait...", {
//       position: "top-right",
//     });
    
//     try {
//       setErrors({});

//       let pdf;
//       let useFallback = false;
      
//       try {
//         pdf = await generateAndSavePDF();
//         console.log("PDF generated successfully using main preview method");
//       } catch (mainError) {
//         console.warn("Main PDF generation failed, trying fallback:", mainError);
//         useFallback = true;
        
//         try {
//           pdf = await generatePDFFromHiddenTarget();
//           console.log("PDF generated successfully using fallback method");
//         } catch (fallbackError) {
//           throw new Error(`PDF generation failed: ${fallbackError.message}`);
//         }
//       }

//       const fileName = `offer_letter_${applicationId || Date.now()}_${Date.now()}.pdf`;
//       const pdfBlob = pdf.output("blob");

//       // Trigger download
//       const url = URL.createObjectURL(pdfBlob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = fileName;
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);
      
//       setTimeout(() => URL.revokeObjectURL(url), 10000);

//       // Metadata for storage
//       const letterMetadata = {
//         letterState: {
//           recipientEmail: state.recipientEmail,
//           recipientName: state.recipientName,
//           subject: `Offer Letter for ${applicant?.role} Position` || state.subject,
//           body: state.body,
//           closingNote: state.closingNote,
//           senderName: state.senderName,
//           senderDesignation: state.senderDesignation,
//           signatureType: state.signatureType,
//           isSigned: state.isSigned,
//           drawnSignature: state.drawnSignature ? "[SIGNATURE_PRESENT]" : null,
//           uploadedSignature: state.uploadedSignatureUrl ? "[SIGNATURE_PRESENT]" : null,
//         },
//         applicant: applicant ? { name: applicant.name, email: applicant.email, id: applicant.id } : null,
//         applicationId,
//         companyProfile: companyProfile ? { name: companyProfile.name, email: companyProfile.email } : null,
//         iquiqueCode,
//         timestamp: new Date().toISOString(),
//         generatedAt: new Date().toLocaleString(),
//         fileName,
//         fileSize: pdfBlob.size,
//         status: "attached",
//       };

//       // Store in localStorage
//       try {
//         localStorage.setItem("attachedOfferLetter", JSON.stringify(letterMetadata));
//         localStorage.setItem("lastOfferLetterId", fileName);
//       } catch (e) {
//         console.warn("localStorage quota exceeded:", e);
//       }

//       // Store in sessionStorage
//       try {
//         sessionStorage.setItem("lastOfferLetterMetadata", JSON.stringify({ ...letterMetadata, timestamp: Date.now() }));
//       } catch (e) {
//         console.warn("sessionStorage failed:", e);
//       }

//       // Store in IndexedDB
//       try {
//         const db = await openOfferLettersDB();
//         await putInDB(db, { 
//           id: fileName, 
//           pdfBlob, 
//           metadata: letterMetadata, 
//           timestamp: Date.now() 
//         });
//         console.log("PDF stored in IndexedDB successfully");
//       } catch (dbErr) {
//         console.warn("IndexedDB storage failed:", dbErr);
//       }

//       toast.update(loadingToast, {
//         render: "Offer letter generated and saved successfully!",
//         type: "success",
//         isLoading: false,
//         autoClose: 3000,
//       });

//       setTimeout(() => navigate(-1), 1500);
      
//     } catch (err) {
//       console.error("Error attaching offer letter:", err);
      
//       toast.update(loadingToast, {
//         render: `Failed to generate PDF: ${err.message}`,
//         type: "error",
//         isLoading: false,
//         autoClose: 5000,
//       });
      
//       setPdfGenerationError(err.message);
//     } finally {
//       setIsAttaching(false);
//     }
//   };

//   const rightButtons = (
//     <div className="d-flex align-items-center gap-3">
//       <button
//         onClick={handleAttachOfferLetter}
//         disabled={isLoading || isSendingEmail || isAttaching}
//         className="btn btn-primary btn-lg w-100 d-flex align-items-center justify-content-center gap-2"
//         style={{
//           backgroundColor: "#4f46e5",
//           borderColor: "#4f46e5",
//           padding: "12px 24px",
//           fontSize: "1rem",
//           fontWeight: 600,
//         }}
//         title="Attach offer letter"
//       >
//         {isAttaching
//           ? <Loader2 className="spinner-border spinner-border-sm" size={20} />
//           : <LinkIcon size={20} />
//         }
//         {isAttaching ? "Generating PDF..." : "Attach Offer Letter"}
//       </button>
//     </div>
//   );

//   const ErrorDisplay = pdfGenerationError && (
//     <div className="alert alert-danger mt-3" role="alert">
//       <strong>PDF Generation Error:</strong> {pdfGenerationError}
//       <br />
//       <small>Please try refreshing the page and ensure all content is loaded before attaching.</small>
//     </div>
//   );

//   return (
//     <div className="vh-100 d-flex flex-column bg-light" style={{ backgroundColor: "#f8fafc" }}>

//       {/* Hidden PDF-capture target - fallback */}
//       <div
//         className="pdf-capture-target"
//         style={{
//           position: "fixed",
//           top: "-99999px",
//           left: "-99999px",
//           visibility: "hidden",
//           overflow: "visible",
//           zIndex: -1,
//           width: "auto",
//         }}
//       >
//         <LetterPreview
//           state={state}
//           selectedTemplate={activeTemplate}
//           companyProfile={companyProfile}
//         />
//       </div>

//       {/* Main Content Grid */}
//       <div className="flex-grow-1 w-100 p-4 overflow-hidden">
//         <div className={`row g-4 h-100 ${!showPreview ? "justify-content-center" : ""}`}>

//           {/* Left: Form column */}
//           <div
//             className={`${showPreview ? "col-lg-6 col-xl-7" : "col-lg-8 col-xl-6"} h-100 overflow-auto pe-2`}
//             style={{ scrollbarWidth: "thin" }}
//           >
//             <div className="d-flex flex-column gap-4 pb-5">
//               <RecipientCard
//                 state={state}
//                 updateState={updateState}
//                 applicant={applicant}
//                 errors={errors}
//               />
//               <LetterContentCard
//                 state={state}
//                 updateState={updateState}
//                 applicant={applicant}
//                 errors={errors}
//               />
//               <SignatureSettingsCard
//                 state={state}
//                 updateState={updateState}
//                 openModal={() => setIsSignatureModalOpen(true)}
//                 openESignModal={() => setIsESignModalOpen(true)}
//               />
//               <QrVerificationCard
//                 templateState={qrCardState}
//                 setTemplateState={handleQrCardUpdate}
//                 errors={errors}
//                 companyName={companyProfile?.name}
//                 iquiqueCode={iquiqueCode}
//               />
//             </div>
//             <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "1rem" }}>
//               {rightButtons}
//               {ErrorDisplay}
//             </div>
//           </div>

//           {/* Right: Preview column */}
//           {showPreview && (
//             <div className="col-lg-6 col-xl-5 h-100 position-relative">
//               <div className="bg-white rounded-3 border shadow-sm h-100 position-relative overflow-hidden">
//                 <button
//                   onClick={() => setIsFullscreenPreview(true)}
//                   className="btn btn-light position-absolute top-0 end-0 m-3 rounded-circle shadow-sm d-flex align-items-center justify-content-center"
//                   style={{ width: "38px", height: "38px", zIndex: 10 }}
//                   title="Full Screen Preview"
//                 >
//                   <Maximize size={18} />
//                 </button>

//                 <div className="h-100 overflow-auto">
//                   <div className="letter-preview-content bg-white">
//                     <LetterPreview
//                       state={state}
//                       selectedTemplate={activeTemplate}
//                       companyProfile={companyProfile}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Signature Modal */}
//       {isSignatureModalOpen && (
//         <SignatureModal
//           initialSignature={state.drawnSignature}
//           onClose={() => setIsSignatureModalOpen(false)}
//           onSave={(signatureData) => {
//             updateState("drawnSignature", signatureData);
//             setIsSignatureModalOpen(false);
//           }}
//         />
//       )}

//       {/* eSign Modal */}
//       {isESignModalOpen && (
//         <ESignModal
//           onClose={() => setIsESignModalOpen(false)}
//           onVerified={handleESignSuccess}
//         />
//       )}

//       {/* Full Screen Preview Modal */}
//       {isFullscreenPreview && (
//         <div
//           className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
//           style={{ backgroundColor: "rgba(15,23,42,0.6)", backdropFilter: "blur(4px)", zIndex: 1050 }}
//         >
//           <div
//             className="bg-white rounded-4 shadow-lg d-flex flex-column"
//             style={{ width: "90%", height: "90%", maxWidth: "1200px" }}
//           >
//             <div className="d-flex justify-content-between align-items-center p-4 border-bottom">
//               <h5 className="fw-bold mb-0">Full Screen Preview</h5>
//               <button
//                 onClick={() => setIsFullscreenPreview(false)}
//                 className="btn btn-link text-dark p-0"
//                 style={{ fontSize: "1.5rem" }}
//               >
//                 <X size={24} />
//               </button>
//             </div>
//             <div className="flex-grow-1 overflow-auto bg-light p-4">
//               <LetterPreview
//                 state={state}
//                 selectedTemplate={activeTemplate}
//                 companyProfile={companyProfile}
//               />
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// import { useEffect, useMemo, useState, useCallback, useRef } from "react";
// import { Eye, EyeOff, Loader2, Mail, Maximize, X, Link as LinkIcon, Save, Send } from "lucide-react";
// import { letterSchema, extractErrors } from "./services/letterValidationSchema.ts";
// import QrVerificationCard from "./components/letter/QrVerificationCard";
// import { ESignModal, LetterContentCard, LetterPreview, RecipientCard, SignatureModal, SignatureSettingsCard } from "./components/index.js";
// import { useLetterhead } from "./hooks/useLetterhead.ts";
// import { useLocation, useNavigate } from "react-router-dom";
// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';
// import { useDispatch, useSelector } from "react-redux";
// import { getTemplates } from "../../../Redux/Reducers/letterHeadReducer.ts";
// import { toast } from "react-toastify";

// // ─── IndexedDB helpers ──────────────────────────────────────────
// const openOfferLettersDB = () =>
//   new Promise((resolve, reject) => {
//     const req = indexedDB.open("OfferLettersDB", 1);
//     req.onupgradeneeded = (e) => {
//       const db = e.target.result;
//       if (!db.objectStoreNames.contains("pdfs")) {
//         db.createObjectStore("pdfs", { keyPath: "id" });
//       }
//     };
//     req.onsuccess = (e) => resolve(e.target.result);
//     req.onerror = (e) => reject(e.target.error);
//   });

// const putInDB = (db, data) =>
//   new Promise((resolve, reject) => {
//     const tx = db.transaction(["pdfs"], "readwrite");
//     tx.objectStore("pdfs").put(data);
//     tx.oncomplete = resolve;
//     tx.onerror = (e) => reject(e.target.error);
//   });

// // ─── Helper to wait for images to load ─────────────────────────
// const waitForImages = (element) => {
//   const images = element.querySelectorAll('img');
//   const promises = Array.from(images).map((img) => {
//     if (img.complete && img.naturalHeight !== 0) {
//       return Promise.resolve();
//     }
//     return new Promise((resolve) => {
//       img.onload = resolve;
//       img.onerror = resolve;
//       // Timeout after 5 seconds to prevent hanging
//       setTimeout(resolve, 5000);
//     });
//   });
//   return Promise.all(promises);
// };

// // ─── Wait for all async operations in component ─────────────────
// const waitForComponentRender = async (element, maxRetries = 10) => {
//   for (let i = 0; i < maxRetries; i++) {
//     // Check if element has content
//     const hasContent = element.innerText && element.innerText.trim().length > 0;
//     const hasImages = element.querySelectorAll('img').length === 0 || 
//                       Array.from(element.querySelectorAll('img')).every(img => img.complete && img.naturalHeight > 0);
    
//     if (hasContent && hasImages) {
//       return true;
//     }
//     await new Promise(r => setTimeout(r, 500));
//   }
//   return false;
// };

// // ─────────────────────────────────────────────────────────────────

// export default function ComposeLetterPage() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const applicant = location.state?.applicant;
//   const applicationId = location.state?.applicationId;
//   const [isRenderReady, setIsRenderReady] = useState(false);
//   const hiddenPreviewRef = useRef(null);
//   //  console.log("applicantNNNNNNNN", applicant)
//   const {
//     templates,
//     isLoading,
//     isEditMode,
//     companyProfile,
//     letterState: state,
//     updateLetterState: updateState,
//     processedTemplate,
//     isSignatureModalOpen,
//     setIsSignatureModalOpen,
//     isESignModalOpen,
//     setIsESignModalOpen,
//     handleSaveLetter: handleSave,
//     handleESignSuccess,
//     setLetterState,
//     iquiqueCode,
//     isSendingEmail,
//   } = useLetterhead();
// console.log("COMPOSESTATE85858585", state)
//   const [errors, setErrors] = useState({});
//   const [showPreview, setShowPreview] = useState(true);
//   const [isFullscreenPreview, setIsFullscreenPreview] = useState(false);
//   const [isAttaching, setIsAttaching] = useState(false);
//   const [pdfGenerationError, setPdfGenerationError] = useState(null);

//   const selectedTemplateFromRedux = useSelector((state) => state.letterHead.template);
//   const ProfessionalExperience =
//     useSelector((state) => state?.ProfileArray?.experienceData?.data) || [];
//   const selectedCompany =
//       useSelector((state) => state?.jobs?.selectedCompany) || {};
//   console.log("selectedCompanyselectedCompany", selectedCompany)

  
//   const activeTemplate = selectedTemplateFromRedux || processedTemplate;
// console.log("ProfessionalExperienceMMMMMMM", ProfessionalExperience)
//   const qrCardState = { ...state, subject: state.subjectQr };


//   useEffect(() => {
//     if (applicant?.role && !state.subject) {
//       updateState("subject", `Offer Letter for ${applicant.role} Position`);
//     }
//   }, [applicant?.role, state.subject, updateState]);

// const matchingCompany = ProfessionalExperience?.find(
//   (exp) => exp?.company_name?.toLowerCase() === selectedCompany?.company_name?.toLowerCase()
// );

//   console.log("matchingExperiencesMMMMNB", matchingCompany)
//   const cid = matchingCompany?.companyDetails?.data?.[0]?.cid || "";
// // console.log("cidcidcid", matchingCompany)
//   const handleQrCardUpdate = (updater) => {
//     setLetterState((prev) => {
//       const newState = typeof updater === "function" ? updater(prev) : updater;
//       if (newState.subject !== undefined && newState.subject !== prev.subject) {
//         return { ...newState, subjectQr: newState.subject, subject: prev.subject };
//       }
//       return newState;
//     });
//   };

//   // ─── Check when hidden preview is ready ────────────────────────
//   useEffect(() => {
//     if (!hiddenPreviewRef.current) return;
    
//     const checkRender = async () => {
//       const element = hiddenPreviewRef.current;
//       const isReady = await waitForComponentRender(element);
//       setIsRenderReady(isReady);
//     };
    
//     // Small delay to allow React to render
//     const timer = setTimeout(checkRender, 1000);
//     return () => clearTimeout(timer);
//   }, [state, activeTemplate, companyProfile]);

//   // ─── Improved PDF Generation with proper waiting ───────────────
//   const generateAndSavePDF = async () => {
//     // First, ensure the hidden preview is ready
//     if (!isRenderReady) {
//       console.log("Waiting for hidden preview to render...");
//       await new Promise(resolve => setTimeout(resolve, 2000));
//     }
    
//     // Use the hidden preview target for consistent capture
//     const captureTarget = hiddenPreviewRef.current;
    
//     if (!captureTarget) {
//       throw new Error('PDF capture target not found');
//     }

//     // Find all page elements
//     const pageElements = captureTarget.querySelectorAll('.single-page');
    
//     if (pageElements.length === 0) {
//       throw new Error('No letter pages found to capture');
//     }

//     // Create a temporary container for capturing at full size
//     const tempContainer = document.createElement('div');
//     tempContainer.style.position = 'fixed';
//     tempContainer.style.top = '-9999px';
//     tempContainer.style.left = '-9999px';
//     tempContainer.style.width = '210mm'; // A4 width
//     tempContainer.style.backgroundColor = '#ffffff';
//     tempContainer.style.zIndex = '-1';
//     document.body.appendChild(tempContainer);

//     // Clone all pages and prepare them for capture
//     const clonedPages = [];
//     for (let i = 0; i < pageElements.length; i++) {
//       const originalPage = pageElements[i];
//       const clone = originalPage.cloneNode(true);
      
//       // Remove any transforms and ensure proper dimensions
//       clone.style.transform = 'none';
//       clone.style.margin = '0';
//       clone.style.position = 'relative';
//       clone.style.top = 'auto';
//       clone.style.left = 'auto';
//       clone.style.overflow = 'visible';
//       clone.style.boxShadow = 'none';
//       clone.style.backgroundColor = '#ffffff';
//       clone.style.width = '210mm';
//       clone.style.minHeight = '297mm';
      
//       tempContainer.appendChild(clone);
//       clonedPages.push(clone);
//     }

//     // Wait for images in clones to load
//     for (const page of clonedPages) {
//       await waitForImages(page);
//     }
    
//     // Additional wait for layout
//     await new Promise((resolve) => setTimeout(resolve, 500));
    
//     // Wait for fonts
//     if (document.fonts && document.fonts.ready) {
//       try {
//         await document.fonts.ready;
//       } catch (e) {
//         console.warn('Font loading warning:', e);
//       }
//     }

//     try {
//       const pdf = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait" });
//       const A4_W = 210;
//       const A4_H = 297;

//       for (let i = 0; i < clonedPages.length; i++) {
//         const page = clonedPages[i];
        
//         // Get the actual dimensions
//         const pageWidth = page.offsetWidth;
//         const pageHeight = page.offsetHeight;
        
//         // Capture with html2canvas
//         const canvas = await html2canvas(page, {
//           scale: 3, // Higher scale for better quality
//           useCORS: true,
//           logging: false,
//           backgroundColor: "#ffffff",
//           allowTaint: false,
//           windowWidth: pageWidth,
//           windowHeight: pageHeight,
//           onclone: (clonedDoc, element) => {
//             // Ensure all styles are applied
//             const pages = clonedDoc.querySelectorAll('.single-page');
//             pages.forEach(p => {
//               p.style.transform = 'none';
//               p.style.margin = '0';
//               p.style.overflow = 'visible';
//             });
//           }
//         });

//         const imgData = canvas.toDataURL("image/png", 1.0);
        
//         // Calculate dimensions to fit A4
//         const imgAspectRatio = canvas.height / canvas.width;
//         let imgWidth = A4_W;
//         let imgHeight = A4_W * imgAspectRatio;

//         if (i > 0) {
//           pdf.addPage();
//         }

//         // Add image to PDF
//         if (imgHeight <= A4_H) {
//           pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
//         } else {
//           // Split content if needed (though pages should already be split)
//           pdf.addImage(imgData, "PNG", 0, 0, imgWidth, A4_H);
//         }
//       }

//       // Clean up
//       document.body.removeChild(tempContainer);
      
//       return pdf;
//     } catch (error) {
//       if (document.body.contains(tempContainer)) {
//         document.body.removeChild(tempContainer);
//       }
//       throw error;
//     }
//   };

//   // ─── Save PDF to localStorage and IndexedDB ────────────────────
//   const savePDFToStorage = async (pdfBlob, fileName, metadata) => {
//     const stores = [];
    
//     // Store metadata in localStorage
//     try {
//       localStorage.setItem("attachedOfferLetter", JSON.stringify(metadata));
//       localStorage.setItem("lastOfferLetterId", fileName);
//       stores.push('localStorage');
//     } catch (e) {
//       console.warn("localStorage quota exceeded:", e);
//     }

//     // Store in sessionStorage as backup
//     try {
//       sessionStorage.setItem("lastOfferLetterMetadata", JSON.stringify({ ...metadata, timestamp: Date.now() }));
//       stores.push('sessionStorage');
//     } catch (e) {
//       console.warn("sessionStorage failed:", e);
//     }

//     // Store in IndexedDB (with actual blob)
//     try {
//       const db = await openOfferLettersDB();
//       await putInDB(db, { 
//         id: fileName, 
//         pdfBlob, 
//         metadata: metadata, 
//         timestamp: Date.now() 
//       });
//       stores.push('IndexedDB');
//       console.log("PDF stored in IndexedDB successfully");
//     } catch (dbErr) {
//       console.warn("IndexedDB storage failed:", dbErr);
//     }
    
//     return stores;
//   };

//   // ─── Attach / Download with proper waiting ────────────────────
//   const handleAttachOfferLetter = async () => {
//     setIsAttaching(true);
//     setPdfGenerationError(null);
    
//     const loadingToast = toast.loading("Generating PDF, please wait...", {
//       position: "top-right",
//       autoClose: false,
//     });
    
//     try {
//       setErrors({});

//       // Wait a bit for any pending renders
//       await new Promise(resolve => setTimeout(resolve, 500));
      
//       const pdf = await generateAndSavePDF();
//       console.log("PDF generated successfully");
      
//       const fileName = `offer_letter_${applicationId || Date.now()}_${Date.now()}.pdf`;
//       const pdfBlob = pdf.output("blob");

//       // Trigger browser download
//       const url = URL.createObjectURL(pdfBlob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = fileName;
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);
      
//       setTimeout(() => URL.revokeObjectURL(url), 10000);

//       // Prepare metadata for storage
//       const letterMetadata = {
//         id: fileName,
//         letterState: {
//           recipientEmail: state.recipientEmail,
//           recipientName: state.recipientName,
//           subject: `Offer Letter for ${applicant?.role} Position` || state.subject,
//           body: state.body,
//           closingNote: state.closingNote,
//           senderName: state.senderName,
//           senderDesignation: state.senderDesignation,
//           signatureType: state.signatureType,
//           isSigned: state.isSigned,
//           hasDrawnSignature: !!state.drawnSignature,
//           hasUploadedSignature: !!state.uploadedSignatureUrl,
//         },
//         applicant: applicant ? { name: applicant.name, email: applicant.email, id: applicant.id } : null,
//         applicationId,
//         companyProfile: companyProfile ? { name: companyProfile.name, email: companyProfile.email } : null,
//         iquiqueCode,
//         timestamp: new Date().toISOString(),
//         generatedAt: new Date().toLocaleString(),
//         fileName,
//         fileSize: pdfBlob.size,
//         status: "attached",
//       };

//       // Save to storage
//       const storedIn = await savePDFToStorage(pdfBlob, fileName, letterMetadata);
//       console.log(`PDF saved to: ${storedIn.join(', ')}`);

//       toast.update(loadingToast, {
//         render: `Offer letter generated and saved successfully! (${(pdfBlob.size / 1024).toFixed(1)} KB)`,
//         type: "success",
//         isLoading: false,
//         autoClose: 3000,
//       });

//       // Navigate after a short delay
//       setTimeout(() => navigate(-1), 1500);
      
//     } catch (err) {
//       console.error("Error attaching offer letter:", err);
      
//       toast.update(loadingToast, {
//         render: `Failed to generate PDF: ${err.message}`,
//         type: "error",
//         isLoading: false,
//         autoClose: 5000,
//       });
      
//       setPdfGenerationError(err.message);
//     } finally {
//       setIsAttaching(false);
//     }
//   };

//   const rightButtons = (
//     <div className="d-flex align-items-center gap-3">
//       <button
//         onClick={handleAttachOfferLetter}
//         disabled={isLoading || isSendingEmail || isAttaching}
//         className="btn btn-primary btn-lg w-100 d-flex align-items-center justify-content-center gap-2"
//         style={{
//           backgroundColor: "#4f46e5",
//           borderColor: "#4f46e5",
//           padding: "12px 24px",
//           fontSize: "1rem",
//           fontWeight: 600,
//         }}
//         title="Attach offer letter"
//       >
//         {isAttaching
//           ? <Loader2 className="spinner-border spinner-border-sm" size={20} />
//           : <LinkIcon size={20} />
//         }
//         {isAttaching ? "Generating PDF..." : "Attach Offer Letter"}
//       </button>
//     </div>
//   );

//   const ErrorDisplay = pdfGenerationError && (
//     <div className="alert alert-danger mt-3" role="alert">
//       <strong>PDF Generation Error:</strong> {pdfGenerationError}
//       <br />
//       <small>Please try refreshing the page and ensure all content is loaded before attaching.</small>
//     </div>
//   );

//   return (
//     <div className="vh-100 d-flex flex-column bg-light" style={{ backgroundColor: "#f8fafc" }}>

//       {/* 
//         Hidden PDF-capture target - Renders at full A4 size
//         This ensures we capture the complete, fully rendered letter
//       */}
//       <div
//         ref={hiddenPreviewRef}
//         className="pdf-capture-target"
//         style={{
//           position: "fixed",
//           top: "-9999px",
//           left: "-9999px",
//           visibility: "hidden",
//           overflow: "visible",
//           zIndex: -1,
//           width: "210mm",
//           backgroundColor: "#ffffff",
//         }}
//       >
//         <div style={{ width: "210mm", margin: 0, padding: 0 }}>
//           <LetterPreview
//             state={state}
//             selectedTemplate={activeTemplate}
//             companyProfile={companyProfile}
//           />
//         </div>
//       </div>

//       {/* Main Content Grid */}
//       <div className="flex-grow-1 w-100 p-4 overflow-hidden">
//         <div className={`row g-4 h-100 ${!showPreview ? "justify-content-center" : ""}`}>

//           {/* Left: Form column */}
//           <div
//             className={`${showPreview ? "col-lg-6 col-xl-7" : "col-lg-8 col-xl-6"} h-100 overflow-auto pe-2`}
//             style={{ scrollbarWidth: "thin" }}
//           >
//             <div className="d-flex flex-column gap-4 pb-5">
//               <RecipientCard
//                 state={state}
//                 updateState={updateState}
//                 applicant={applicant}
//                 errors={errors}
//               />
//               <LetterContentCard
//                 state={state}
//                 updateState={updateState}
//                 applicant={applicant}
//                 errors={errors}
//               />
//               <SignatureSettingsCard
//                 state={state}
//                 updateState={updateState}
//                 openModal={() => setIsSignatureModalOpen(true)}
//                 openESignModal={() => setIsESignModalOpen(true)}
//               />
//               <QrVerificationCard
//                 templateState={qrCardState}
//                 setTemplateState={handleQrCardUpdate}
//                 errors={errors}
//                 companyName={companyProfile?.name}
//                 iquiqueCode={iquiqueCode}
//               />
//             </div>
//             <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "1rem" }}>
//               {applicant ? {rightButtons} : ""}
//               {ErrorDisplay}
//             </div>
//           </div>

//           {/* Right: Preview column */}
//           {showPreview && (
//             <div className="col-lg-6 col-xl-5 h-100 position-relative">
//               <div className="bg-white rounded-3 border shadow-sm h-100 position-relative overflow-hidden">
//                 <button
//                   onClick={() => setIsFullscreenPreview(true)}
//                   className="btn btn-light position-absolute top-0 end-0 m-3 rounded-circle shadow-sm d-flex align-items-center justify-content-center"
//                   style={{ width: "38px", height: "38px", zIndex: 10 }}
//                   title="Full Screen Preview"
//                 >
//                   <Maximize size={18} />
//                 </button>

//                 <div className="h-100 overflow-auto">
//                   <div className="letter-preview-content bg-white">
//                     <LetterPreview
//                       state={state}
//                       selectedTemplate={activeTemplate}
//                       companyProfile={companyProfile}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Signature Modal */}
//       {isSignatureModalOpen && (
//         <SignatureModal
//           initialSignature={state.drawnSignature}
//           onClose={() => setIsSignatureModalOpen(false)}
//           onSave={(signatureData) => {
//             updateState("drawnSignature", signatureData);
//             setIsSignatureModalOpen(false);
//           }}
//         />
//       )}

//       {/* eSign Modal */}
//       {isESignModalOpen && (
//         <ESignModal
//           onClose={() => setIsESignModalOpen(false)}
//           onVerified={handleESignSuccess}
//         />
//       )}

//       {/* Full Screen Preview Modal */}
//       {isFullscreenPreview && (
//         <div
//           className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
//           style={{ backgroundColor: "rgba(15,23,42,0.6)", backdropFilter: "blur(4px)", zIndex: 1050 }}
//         >
//           <div
//             className="bg-white rounded-4 shadow-lg d-flex flex-column"
//             style={{ width: "90%", height: "90%", maxWidth: "1200px" }}
//           >
//             <div className="d-flex justify-content-between align-items-center p-4 border-bottom">
//               <h5 className="fw-bold mb-0">Full Screen Preview</h5>
//               <button
//                 onClick={() => setIsFullscreenPreview(false)}
//                 className="btn btn-link text-dark p-0"
//                 style={{ fontSize: "1.5rem" }}
//               >
//                 <X size={24} />
//               </button>
//             </div>
//             <div className="flex-grow-1 overflow-auto bg-light p-4">
//               <LetterPreview
//                 state={state}
//                 selectedTemplate={activeTemplate}
//                 companyProfile={companyProfile}
//               />
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


import { useEffect, useMemo, useState } from "react";
import { Eye, EyeOff, Loader2, Mail, Maximize, X, Link as LinkIcon, Save, Send } from "lucide-react";
import { letterSchema, extractErrors } from "./services/letterValidationSchema.ts";
import QrVerificationCard from "./components/letter/QrVerificationCard";
import { ESignModal, LetterContentCard, LetterPreview, RecipientCard, SignatureModal, SignatureSettingsCard } from "./components/index.js";
import { useLetterhead } from "./hooks/useLetterhead.ts";
import { useLocation, useNavigate } from "react-router-dom";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useDispatch, useSelector } from "react-redux";
import { getTemplates } from "../../../Redux/Reducers/letterHeadReducer.ts";
import { toast } from "react-toastify";

// ─── IndexedDB helpers ──────────────────────────────────────────
const openOfferLettersDB = () =>
  new Promise((resolve, reject) => {
    const req = indexedDB.open("OfferLettersDB", 1);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains("pdfs")) {
        db.createObjectStore("pdfs", { keyPath: "id" });
      }
    };
    req.onsuccess = (e) => resolve(e.target.result);
    req.onerror = (e) => reject(e.target.error);
  });

const putInDB = (db, data) =>
  new Promise((resolve, reject) => {
    const tx = db.transaction(["pdfs"], "readwrite");
    tx.objectStore("pdfs").put(data);
    tx.oncomplete = resolve;
    tx.onerror = (e) => reject(e.target.error);
  });

// ─────────────────────────────────────────────────────────────────

export default function ComposeLetterPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const applicant = location.state?.applicant;
  const applicationId = location.state?.applicationId;

  const {
    templates,
    isLoading,
    isEditMode,
    companyProfile,
    letterState: state,
    updateLetterState: updateState,
    processedTemplate,
    isSignatureModalOpen,
    setIsSignatureModalOpen,
    isESignModalOpen,
    setIsESignModalOpen,
    handleSaveLetter: handleSave,
    handleESignSuccess,
    setLetterState,
    iquiqueCode,
    isSendingEmail,
  } = useLetterhead();

  const [errors, setErrors] = useState({});
  const [showPreview, setShowPreview] = useState(true);
  const [isFullscreenPreview, setIsFullscreenPreview] = useState(false);
  const [isAttaching, setIsAttaching] = useState(false);
  const [pdfGenerationError, setPdfGenerationError] = useState(null);

  const selectedTemplateFromRedux = useSelector((state) => state.letterHead.template);
  const ProfessionalExperience =
    useSelector((state) => state?.ProfileArray?.experienceData?.data) || [];
  const cid = ProfessionalExperience[0]?.companyDetails?.data[0]?.cid || "";
  const activeTemplate = selectedTemplateFromRedux || processedTemplate;

  const qrCardState = { ...state, subject: state.subjectQr };

  useEffect(() => {
    if (applicant?.role && !state.subject) {
      updateState("subject", `Offer Letter for ${applicant.role} Position`);
    }
  }, [applicant?.role, state.subject, updateState]);

  const handleQrCardUpdate = (updater) => {
    setLetterState((prev) => {
      const newState = typeof updater === "function" ? updater(prev) : updater;
      if (newState.subject !== undefined && newState.subject !== prev.subject) {
        return { ...newState, subjectQr: newState.subject, subject: prev.subject };
      }
      return newState;
    });
  };

  // ─── IMPROVED PDF Generation with html2canvas ───
  const generateAndSavePDF = async () => {
    const previewContainer = document.querySelector('.letter-preview-content');
    
    if (!previewContainer) {
      throw new Error('Preview content not found - please make sure the letter preview is visible');
    }

    const pageElements = previewContainer.querySelectorAll('.single-page');
    
    if (pageElements.length === 0) {
      throw new Error('No letter pages found to capture');
    }

    const tempContainer = document.createElement('div');
    tempContainer.style.position = 'fixed';
    tempContainer.style.top = '-9999px';
    tempContainer.style.left = '-9999px';
    tempContainer.style.width = 'auto';
    tempContainer.style.height = 'auto';
    tempContainer.style.backgroundColor = '#ffffff';
    tempContainer.style.zIndex = '-1';
    document.body.appendChild(tempContainer);

    const clonedPages = [];
    for (let i = 0; i < pageElements.length; i++) {
      const originalPage = pageElements[i];
      const clone = originalPage.cloneNode(true);
      
      clone.style.transform = 'none';
      clone.style.margin = '0';
      clone.style.position = 'relative';
      clone.style.top = 'auto';
      clone.style.left = 'auto';
      clone.style.overflow = 'hidden';
      clone.style.boxShadow = 'none';
      clone.style.backgroundColor = '#ffffff';
      
      const width = originalPage.offsetWidth;
      const height = originalPage.offsetHeight;
      clone.style.width = `${width}px`;
      clone.style.height = `${height}px`;
      clone.style.minWidth = `${width}px`;
      clone.style.minHeight = `${height}px`;
      
      tempContainer.appendChild(clone);
      clonedPages.push(clone);
    }

    await new Promise((resolve) => setTimeout(resolve, 300));
    
    if (document.fonts && document.fonts.ready) {
      try {
        await document.fonts.ready;
      } catch (e) {
        console.warn('Font loading warning:', e);
      }
    }

    const allImages = tempContainer.querySelectorAll('img');
    await Promise.all(
      Array.from(allImages).map(
        (img) =>
          new Promise((resolve) => {
            if (img.complete && img.naturalHeight !== 0) {
              resolve();
            } else {
              img.onload = resolve;
              img.onerror = resolve;
              setTimeout(resolve, 1000);
            }
          })
      )
    );

    try {
      const pdf = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait" });
      const A4_W = 210;
      const A4_H = 297;

      for (let i = 0; i < clonedPages.length; i++) {
        const page = clonedPages[i];
        
        const canvas = await html2canvas(page, {
          scale: 2.5,
          useCORS: true,
          logging: false,
          backgroundColor: "#ffffff",
          allowTaint: false,
          foreignObjectRendering: false,
          onclone: (clonedDoc, element) => {
            element.style.overflow = 'hidden';
          }
        });

        const imgData = canvas.toDataURL("image/png");
        const imgWidth = A4_W;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        if (i > 0) {
          pdf.addPage();
        }

        if (imgHeight <= A4_H) {
          pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
        } else {
          const scaleRatio = A4_H / imgHeight;
          pdf.addImage(imgData, "PNG", 0, 0, imgWidth * scaleRatio, A4_H);
        }
      }

      document.body.removeChild(tempContainer);
      return pdf;
    } catch (error) {
      if (document.body.contains(tempContainer)) {
        document.body.removeChild(tempContainer);
      }
      throw error;
    }
  };

  // ─── Alternative method using hidden div (fallback) ───
  const generatePDFFromHiddenTarget = async () => {
    const captureTarget = document.querySelector('.pdf-capture-target');
    
    if (!captureTarget) {
      throw new Error('PDF capture target not found');
    }

    const pages = captureTarget.querySelectorAll('.single-page');
    
    if (pages.length === 0) {
      throw new Error('No pages found in capture target');
    }

    const originalVisibility = captureTarget.style.visibility;
    const originalTop = captureTarget.style.top;
    const originalLeft = captureTarget.style.left;
    
    captureTarget.style.visibility = 'visible';
    captureTarget.style.top = '0';
    captureTarget.style.left = '0';
    captureTarget.style.position = 'fixed';
    captureTarget.style.zIndex = '-1';
    
    await new Promise(resolve => setTimeout(resolve, 100));

    const pdf = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait" });
    const A4_W = 210;

    for (let i = 0; i < pages.length; i++) {
      const canvas = await html2canvas(pages[i], {
        scale: 2.5,
        useCORS: true,
        backgroundColor: "#ffffff",
      });
      
      const imgData = canvas.toDataURL("image/png");
      const imgHeight = (canvas.height * A4_W) / canvas.width;
      
      if (i > 0) pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, 0, A4_W, imgHeight);
    }
    
    captureTarget.style.visibility = originalVisibility;
    captureTarget.style.top = originalTop;
    captureTarget.style.left = originalLeft;
    
    return pdf;
  };

  // ─── Attach / Download with retry logic ───
  const handleAttachOfferLetter = async () => {
    setIsAttaching(true);
    setPdfGenerationError(null);
    
    const loadingToast = toast.loading("Generating PDF, please wait...", {
      position: "top-right",
    });
    
    try {
      setErrors({});

      let pdf;
      
      try {
        pdf = await generateAndSavePDF();
        console.log("PDF generated successfully using main preview method");
      } catch (mainError) {
        console.warn("Main PDF generation failed, trying fallback:", mainError);
        
        try {
          pdf = await generatePDFFromHiddenTarget();
          console.log("PDF generated successfully using fallback method");
        } catch (fallbackError) {
          throw new Error(`Both PDF generation methods failed. Main: ${mainError.message}, Fallback: ${fallbackError.message}`);
        }
      }

      const fileName = `offer_letter_${applicationId || Date.now()}_${Date.now()}.pdf`;
      const pdfBlob = pdf.output("blob");

      const url = URL.createObjectURL(pdfBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      
      setTimeout(() => URL.revokeObjectURL(url), 10000);

      const letterMetadata = {
        letterState: {
          recipientEmail: state.recipientEmail,
          recipientName: state.recipientName,
          subject: `Offer Letter for ${applicant?.role} Position` || state.subject,
          body: state.body,
          closingNote: state.closingNote,
          senderName: state.senderName,
          senderDesignation: state.senderDesignation,
          signatureType: state.signatureType,
          isSigned: state.isSigned,
          drawnSignature: state.drawnSignature ? "[SIGNATURE_PRESENT]" : null,
          uploadedSignature: state.uploadedSignatureUrl ? "[SIGNATURE_PRESENT]" : null,
        },
        applicant: applicant ? { name: applicant.name, email: applicant.email, id: applicant.id } : null,
        applicationId,
        companyProfile: companyProfile ? { name: companyProfile.name, email: companyProfile.email } : null,
        iquiqueCode,
        timestamp: new Date().toISOString(),
        generatedAt: new Date().toLocaleString(),
        fileName,
        fileSize: pdfBlob.size,
        status: "attached",
      };

      try {
        localStorage.setItem("attachedOfferLetter", JSON.stringify(letterMetadata));
        localStorage.setItem("lastOfferLetterId", fileName);
      } catch (e) {
        console.warn("localStorage quota exceeded:", e);
      }

      try {
        sessionStorage.setItem("lastOfferLetterMetadata", JSON.stringify({ ...letterMetadata, timestamp: Date.now() }));
      } catch (e) {
        console.warn("sessionStorage failed:", e);
      }

      try {
        const db = await openOfferLettersDB();
        await putInDB(db, { 
          id: fileName, 
          pdfBlob, 
          metadata: letterMetadata, 
          timestamp: Date.now() 
        });
        console.log("PDF stored in IndexedDB successfully");
      } catch (dbErr) {
        console.warn("IndexedDB storage failed (download still succeeded):", dbErr);
      }

      toast.update(loadingToast, {
        render: "Offer letter generated and saved successfully!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });

      setTimeout(() => navigate(-1), 1500);
      
    } catch (err) {
      console.error("Error attaching offer letter:", err);
      
      toast.update(loadingToast, {
        render: `Failed to generate PDF: ${err.message}`,
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
      
      setPdfGenerationError(err.message);
    } finally {
      setIsAttaching(false);
    }
  };

  const rightButtons = (
    <div className="d-flex align-items-center gap-3">
      <button
        onClick={handleAttachOfferLetter}
        disabled={isLoading || isSendingEmail || isAttaching}
        className="btn btn-primary btn-lg w-100 d-flex align-items-center justify-content-center gap-2"
        style={{
          backgroundColor: "#4f46e5",
          borderColor: "#4f46e5",
          padding: "12px 24px",
          fontSize: "1rem",
          fontWeight: 600,
        }}
        title="Attach offer letter"
      >
        {isAttaching
          ? <Loader2 className="spinner-border spinner-border-sm" size={20} />
          : <LinkIcon size={20} />
        }
        {isAttaching ? "Generating PDF..." : "Attach Offer Letter"}
      </button>
    </div>
  );

  const ErrorDisplay = pdfGenerationError && (
    <div className="alert alert-danger mt-3" role="alert">
      <strong>PDF Generation Error:</strong> {pdfGenerationError}
      <br />
      <small>Please try refreshing the page and ensure all content is loaded before attaching.</small>
    </div>
  );

  return (
    <div className="vh-100 d-flex flex-column bg-light" style={{ backgroundColor: "#f8fafc" }}>

      <div
        className="pdf-capture-target"
        style={{
          position: "fixed",
          top: "-99999px",
          left: "-99999px",
          visibility: "hidden",
          overflow: "visible",
          zIndex: -1,
          width: "auto",
        }}
      >
        <LetterPreview
          state={state}
          selectedTemplate={activeTemplate}
          companyProfile={companyProfile}
        />
      </div>

      <div className="flex-grow-1 w-100 p-4 overflow-hidden">
        <div className={`row g-4 h-100 ${!showPreview ? "justify-content-center" : ""}`}>

          <div
            className={`${showPreview ? "col-lg-6 col-xl-7" : "col-lg-8 col-xl-6"} h-100 overflow-auto pe-2`}
            style={{ scrollbarWidth: "thin" }}
          >
            <div className="d-flex flex-column gap-4 pb-5">
              <RecipientCard
                state={state}
                updateState={updateState}
                applicant={applicant}
                errors={errors}
              />
              <LetterContentCard
                state={state}
                updateState={updateState}
                applicant={applicant}
                errors={errors}
              />
              <SignatureSettingsCard
                state={state}
                updateState={updateState}
                openModal={() => setIsSignatureModalOpen(true)}
                openESignModal={() => setIsESignModalOpen(true)}
              />
              <QrVerificationCard
                templateState={qrCardState}
                setTemplateState={handleQrCardUpdate}
                errors={errors}
                companyName={companyProfile?.name}
                iquiqueCode={iquiqueCode}
              />
            </div>
            <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "1rem" }}>
              {rightButtons}
              {ErrorDisplay}
            </div>
          </div>

          {showPreview && (
            <div className="col-lg-6 col-xl-5 h-100 position-relative">
              <div className="bg-white rounded-3 border shadow-sm h-100 position-relative overflow-hidden">
                <button
                  onClick={() => setIsFullscreenPreview(true)}
                  className="btn btn-light position-absolute top-0 end-0 m-3 rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                  style={{ width: "38px", height: "38px", zIndex: 10 }}
                  title="Full Screen Preview"
                >
                  <Maximize size={18} />
                </button>

                <div className="h-100 overflow-auto">
                  <div className="letter-preview-content bg-white">
                    <LetterPreview
                      state={state}
                      selectedTemplate={activeTemplate}
                      companyProfile={companyProfile}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {isSignatureModalOpen && (
        <SignatureModal
          initialSignature={state.drawnSignature}
          onClose={() => setIsSignatureModalOpen(false)}
          onSave={(signatureData) => {
            updateState("drawnSignature", signatureData);
            setIsSignatureModalOpen(false);
          }}
        />
      )}

      {isESignModalOpen && (
        <ESignModal
          onClose={() => setIsESignModalOpen(false)}
          onVerified={handleESignSuccess}
        />
      )}

      {isFullscreenPreview && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ backgroundColor: "rgba(15,23,42,0.6)", backdropFilter: "blur(4px)", zIndex: 1050 }}
        >
          <div
            className="bg-white rounded-4 shadow-lg d-flex flex-column"
            style={{ width: "90%", height: "90%", maxWidth: "1200px" }}
          >
            <div className="d-flex justify-content-between align-items-center p-4 border-bottom">
              <h5 className="fw-bold mb-0">Full Screen Preview</h5>
              <button
                onClick={() => setIsFullscreenPreview(false)}
                className="btn btn-link text-dark p-0"
                style={{ fontSize: "1.5rem" }}
              >
                <X size={24} />
              </button>
            </div>
            <div className="flex-grow-1 overflow-auto bg-light p-4">
              <LetterPreview
                state={state}
                selectedTemplate={activeTemplate}
                companyProfile={companyProfile}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}